import "bootstrap/dist/css/bootstrap.min.css";
import React, { useCallback, useEffect, useState, useMemo  } from "react";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const HRBudgetSystem = () => {
  // ✅ CONFIGURAÇÃO DA API
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const [activeTab, setActiveTab] = useState("salarios");
  const [selectedCostCenter, setSelectedCostCenter] = useState("");
  const [showSalaryModal, setShowSalaryModal] = useState(false);
  const [showChargesModal, setShowChargesModal] = useState(false);
  const [showDissidioModal] = useState(false);
  const [showDissidioGeralModal, setShowDissidioGeralModal] = useState(false);
  const [showMeritoModal, setShowMeritoModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showMonthlyEvolution, setShowMonthlyEvolution] = useState(false);
  const [editandoContratacao, setEditandoContratacao] = useState(null);

  // Novo estado para drill-down
  const [expandedCostCenter, setExpandedCostCenter] = useState("");

  // Estados para loading e dados da API
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  const [employeesData, setEmployeesData] = useState([]);

  const [employeesDataGlobal, setEmployeesDataGlobal] = useState([]);

  const [loadingCostCenters, setLoadingCostCenters] = useState(false);
  const [costCentersData, setCostCentersData] = useState([]);

  const [realizadoOrcadoData, setRealizadoOrcado] = useState([]);
  const [, setemployeesrealizadoOrcadoData] = useState([]);

  const [expandedCostCenterComparative, setExpandedCostCenterComparative] =
    useState("");

  const [dissidioGeralData, setDissidioGeralData] = useState({
    mes: "",
    valor: "",
    tipo: "",
  });

  const [meritoData, setMeritoData] = useState({
    mes: "",
    valor: "",
    chapa: "",
  });

  // Estados para nova contratação
  const [novaContratacao, setNovaContratacao] = useState({
    area: "",
    vaga: "",
    salario: "",
  });

  const [contratacoesCadastradas, setContratacoesCadastradas] = useState([]);
  const [loadingContratacoes, setLoadingContratacoes] = useState(false);

  // Estados para treinamentos
  const [novoTreinamento, setNovoTreinamento] = useState({
    centrocusto: "",
    curso: "",
    participante: "",
    duracao: "",
    valor: "",
  });

  const [treinamentosCadastrados, setTreinamentosCadastrados] = useState([]);
  const [loadingTreinamentos, setLoadingTreinamentos] = useState(false);
  const [editandoTreinamento, setEditandoTreinamento] = useState(null);

  // Adicionar estes estados no início do componente (junto com os outros useState)
  const [selectedPeriod] = useState(localStorage.getItem("selectedYear"));
  const [selectedCostCenterFilter] = useState("");

  // #region  ✅ FUNÇÃO PARA CARREGAR DADOS DE RH
  const carregarDadosRealizadoxOrcado = useCallback(
    async (centroCusto, ano = localStorage.getItem("selectedYear")) => {
      try {
        setLoadingEmployees(true);
        const token = localStorage.getItem("authToken");
        if (!token) {
          console.error("❌ Token não encontrado");
          return;
        }

        const PCODCOLIGADA = localStorage.getItem("PCODCOLIGADA");
        const PCODFILIAL = localStorage.getItem("PCODFILIAL");

        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };

        // ✅ CONSTRUÇÃO DA WHERE CLAUSE PARA RH
        let whereClause = `AND CODCOLIGADA = '${PCODCOLIGADA}' AND CODFILIAL = '${PCODFILIAL}' AND ANO = '${ano}'`;

        console.log(
          "🔍 Carregando dados de RH com sql_MAN_ORC_RH1:",
          whereClause
        );

        const response = await fetch(
          `${API_BASE_URL}/totvs-sql/sql_MAN_ORC_RH1/filter`,
          {
            method: "POST",
            headers,
            body: JSON.stringify({
              WHERE: whereClause,
            }),
          }
        );

        const result = await response.json();
        console.log("📋 Resultado dos dados de RH sql_MAN_ORC_RH1", result);

        if (result.success && result.data) {
          // ✅ MAPEAR DADOS DOS FUNCIONÁRIOS
          const RealizadoOrcado = result.data.map((item) => ({
            CODCOLIGADA: item.CODCOLIGADA,
            CODFILIAL: item.CODFILIAL,
            CHAPA: item.CHAPA,
            FUNCIONARIO: item.FUNCIONARIO,
            FUNCAO: item.FUNCAO,
            CENTROCUSTO: item.CENTROCUSTO,
            RATEIO: item.RATEIO,
            SALARIO_ORCAMENTO: parseFloat(item.SALARIO_ORCAMENTO || 0),
            SALARIO_REALIZADO: parseFloat(item.SALARIO_REALIZADO || 0),
            ENCARGOS_ORCAMENTO: parseFloat(item.ENCARGOS_ORCAMENTO || 0),
            ENCARGOS_REALIZADOS: parseFloat(item.ENCARGOS_REALIZADOS || 0),
            TOTAL_ORCADO: parseFloat(item.TOTAL_ORCADO || 0),
            TOTAL_REALIZAZADO: parseFloat(item.TOTAL_REALIZAZADO || 0),
            PERCENTUAL: parseFloat(item.PERCENTUAL || 0),
            SALARIOVARIAVEL: parseFloat(item.SALARIOVARIAVEL || 0),

            // Dados originais para referência
            originalData: item,
          }));

          setRealizadoOrcado(RealizadoOrcado);
          setemployeesrealizadoOrcadoData(RealizadoOrcado);
        } else {
          console.log("⚠️ Nenhum funcionário encontrado");
          setRealizadoOrcado([]);
        }
      } catch (error) {
        console.error("❌ Erro ao carregar dados de RH:", error);
        setRealizadoOrcado([]);
      } finally {
      }
    },
    [API_BASE_URL]
  );
  //#endregion

  useEffect(() => {
    carregarDadosRealizadoxOrcado(selectedCostCenterFilter);
  }, [carregarDadosRealizadoxOrcado, selectedCostCenterFilter]);

  // #region  helpers de agregação
  const groupBy = (arr, key) =>
    arr.reduce((acc, cur) => {
      (acc[cur[key]] = acc[cur[key]] || []).push(cur);
      return acc;
    }, {});

  const aggregate = (data, field) =>
    data.reduce((sum, cur) => sum + (cur[field] || 0), 0);

  const getOrcadoData = () => {
    /*const totalFuncionarios = new Set(realizadoOrcadoData.map((i) => i.CHAPA))
      .size;*/

    const totalFuncionarios = new Set(
      realizadoOrcadoData
        .filter((i) => i.SALARIO_ORCAMENTO > 0) // Filtrar apenas salários > 0
        .map((i) => i.CHAPA)
    ).size;

    const totalSalarios = aggregate(realizadoOrcadoData, "SALARIO_ORCAMENTO");
    const totalEncargos = aggregate(realizadoOrcadoData, "ENCARGOS_ORCAMENTO");
    const custoTotal = totalSalarios + totalEncargos;

    const totalSalariosOrc = aggregate(
      realizadoOrcadoData,
      "SALARIO_ORCAMENTO"
    );
    const totalEncargosOrc = aggregate(
      realizadoOrcadoData,
      "ENCARGOS_ORCAMENTO"
    );
    const custoTotalOrc = totalSalarios + totalEncargos;

    const dadosPorCentro = Object.entries(
      groupBy(realizadoOrcadoData, "CENTROCUSTO")
    ).reduce((acc, [centro, items]) => {
      acc[centro] = {
        funcionarios: new Set(
          items.filter((i) => i.SALARIO_ORCAMENTO > 0).map((i) => i.CHAPA)
        ).size,
        salarios: aggregate(items, "SALARIO_ORCAMENTO"),
        encargos: aggregate(items, "ENCARGOS_ORCAMENTO"),
      };
      return acc;
    }, {});

    return {
      totalFuncionarios,
      totalSalarios,
      totalEncargos,
      custoTotal,
      dadosPorCentro,
      totalSalariosOrc,
      totalEncargosOrc,
      custoTotalOrc,
    };
  };

  const getDashboardDataOrcadoRealizado = () => {
    const totalFuncionarios = new Set(realizadoOrcadoData.map((i) => i.CHAPA))
      .size;
    const totalSalarios = aggregate(realizadoOrcadoData, "SALARIO_REALIZADO");
    const totalEncargos = aggregate(realizadoOrcadoData, "ENCARGOS_REALIZADOS");
    const custoTotalRealizado = totalSalarios + totalEncargos;
    const dadosPorCentro = Object.entries(
      groupBy(realizadoOrcadoData, "CENTROCUSTO")
    ).reduce((acc, [centro, items]) => {
      acc[centro.replace(/"/g, "").trim()] = {
        funcionarios: new Set(items.map((i) => i.CHAPA)).size,
        salarios: aggregate(items, "SALARIO_REALIZADO"),
        encargos: aggregate(items, "ENCARGOS_REALIZADOS"),
      };
      return acc;
    }, {});
    return {
      totalFuncionarios,
      totalSalarios,
      totalEncargos,
      custoTotalRealizado,
      dadosPorCentro,
    };
  };

  const getEmployeesByCostCenterOrcRealizado = (centro) =>
    (realizadoOrcadoData.filter((i) => i.CENTROCUSTO === centro) || []).map(
      (i) => ({
        id: i.CHAPA,
        name: i.FUNCIONARIO,
        position: i.FUNCAO,
        salaryOrcado: i.SALARIO_ORCAMENTO,
        salaryRealizado: i.SALARIO_REALIZADO,
        encargoOrcado: i.ENCARGOS_ORCAMENTO,
        encargoRealizado: i.ENCARGOS_REALIZADOS,
        totalOrcado: i.TOTAL_ORCADO,
        totalRealizado: i.TOTAL_REALIZAZADO,
      })
    );

  const getProjectionData = () => {
    // Dados realizados
    const { totalSalarios, totalEncargos, totalFuncionarios } =
      getDashboardDataOrcadoRealizado();

    // Dados orçados (fallback para realizado, caso venha undefined)
    const { totalSalariosOrc, totalEncargosOrc } = getOrcadoData();

    // Mês atual (1–12)
    const currentMonth = new Date().getMonth() + 1;

    console.log("Mes...." + currentMonth);

    // Projeções anuais (realizado)
    const salariosProjetados = Math.round((totalSalarios / currentMonth) * 12);
    const encargosProjetados = Math.round((totalEncargos / currentMonth) * 12);
    const custoTotalProjetado = salariosProjetados + encargosProjetados;

    // Percentuais de realizado vs orçado
    const SalarioProjetadoPerc =
      totalSalariosOrc > 0
        ? Math.round((salariosProjetados / totalSalariosOrc) * 100)
        : 0;

    const EncargosProjetadoPerc =
      totalEncargosOrc > 0
        ? Math.round((encargosProjetados / totalEncargosOrc) * 100)
        : 0;

    const TotalProjetadoPerc =
      totalSalariosOrc + totalEncargosOrc > 0
        ? Math.round(
            (custoTotalProjetado / (totalSalariosOrc + totalEncargosOrc)) * 100
          )
        : 0;

    return {
      // valores brutos realizados
      totalSalarios,
      totalEncargos,
      totalFuncionarios,

      // valores brutos orçados
      totalSalariosOrc,
      totalEncargosOrc,

      // projeções anualizadas (realizado)
      salariosProjetados,
      encargosProjetados,
      funcionariosProjetados: totalFuncionarios,
      custoTotalProjetado,

      // percentuais de realizado vs orçado
      SalarioProjetadoPerc,
      EncargosProjetadoPerc,
      TotalProjetadoPerc,
      currentMonth,
    };
  };

  // Função para toggle do drill-down comparativo
  const toggleDrillDownComparative = (costCenter) => {
    if (expandedCostCenterComparative === costCenter) {
      setExpandedCostCenterComparative("");
    } else {
      setExpandedCostCenterComparative(costCenter);
    }
  };

  //#endregion

  // #region ✅ FUNÇÃO PARA CARREGAR CENTROS DE CUSTO ÚNICOS
  const carregarCentrosCusto = useCallback(async () => {
    try {
      setLoadingCostCenters(true);
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("❌ Token não encontrado");
        return;
      }

      const selectedYear = localStorage.getItem("selectedYear") || "2025";
      const PCODCOLIGADA = localStorage.getItem("PCODCOLIGADA");
      const PCODFILIAL = localStorage.getItem("PCODFILIAL");

      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      // ✅ BUSCAR CENTROS DE CUSTO DISTINTOS
      let whereClause = `AND CODCOLIGADA = '${PCODCOLIGADA}' AND CODFILIAL = '${PCODFILIAL}' AND ANO='${selectedYear}' `;

      console.log("🔍 Carregando centros de custo únicos...");

      const response = await fetch(
        `${API_BASE_URL}/totvs-sql/sql_MAN_ORC_RH/filter`,
        {
          method: "POST",
          headers,
          body: JSON.stringify({
            WHERE: whereClause,
          }),
        }
      );

      const result = await response.json();
      console.log("📋 Resultado dos centros de custo:", result);

      if (result.success && result.data) {
        // ✅ REMOÇÃO DE DUPLICATAS NO FRONTEND
        const centrosCustoUnicos = result.data.reduce((acc, item) => {
          const existe = acc.find((cc) => cc.CODCCUSTO === item.CODCCUSTO);
          if (!existe) {
            acc.push(item);
          }
          return acc;
        }, []);

        const centrosCustoMapeados = centrosCustoUnicos.map((item) => ({
          codigo: item.CODCCUSTO || "",
          nome: item.CENTROCUSTO || "N/A",
        }));

        setCostCentersData(centrosCustoMapeados);
        console.log(
          "✅ Centros de custo carregados:",
          centrosCustoMapeados.length
        );
      } else {
        console.log("⚠️ Nenhum centro de custo encontrado");
        setCostCentersData([]);
      }
    } catch (error) {
      console.error("❌ Erro ao carregar centros de custo:", error);
      setCostCentersData([]);
    } finally {
      setLoadingCostCenters(false);
    }
  }, [API_BASE_URL]);

  //#endregion

  // #region ✅ FUNÇÃO PARA CARREGAR DADOS DE RH
  const carregarDadosRH = useCallback(
    async (centroCusto, ano = localStorage.getItem("selectedYear")) => {
      try {
        setLoadingEmployees(true);
        const token = localStorage.getItem("authToken");
        if (!token) {
          console.error("❌ Token não encontrado");
          return;
        }

        const PCODCOLIGADA = localStorage.getItem("PCODCOLIGADA");
        const PCODFILIAL = localStorage.getItem("PCODFILIAL");

        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };

        // ✅ CONSTRUÇÃO DA WHERE CLAUSE PARA RH
        let whereClause = `AND CODCOLIGADA = '${PCODCOLIGADA}' AND CODFILIAL = '${PCODFILIAL}' AND ANO='${ano}' `;

        if (centroCusto && centroCusto !== "" && centroCusto !== "%") {
          whereClause += ` AND CODCCUSTO = '${centroCusto}'`;
        }

        console.log("🔍 Carregando dados de RH com WHERE:", whereClause);

        const response = await fetch(
          `${API_BASE_URL}/totvs-sql/sql_MAN_ORC_RH/filter`,
          {
            method: "POST",
            headers,
            body: JSON.stringify({
              WHERE: whereClause,
            }),
          }
        );

        const result = await response.json();
        console.log("📋 Resultado dos dados de RH:", result);

        if (result.success && result.data) {
          // ✅ MAPEAR DADOS DOS FUNCIONÁRIOS
          const funcionariosMapeados = result.data.map((item) => ({
            id: item.CHAPA || item.IDRH,
            name: item.FUNCIONARIO || "N/A",
            position: item.FUNCAO || "N/A",
            salary: parseFloat(item.SALARIO || 0),
            costCenter: item.CENTROCUSTO || "N/A",
            codCostCenter: item.CODCCUSTO || "",
            rateio: parseFloat(item.RATEIO || 100),
            tipoFunc: item.TIPOFUNC || "Normal",

            // Dados de dissídio e mérito
            dissidioMes: item.DISSIOMES || "",
            meritoMes: item.MERITOMES || "",
            merito: parseFloat(item.MERITO || 0),
            dissidio: parseFloat(item.DISSIDIO || 0),

            // Encargos
            fgts: parseFloat(item.FGTS || 0),
            pis: parseFloat(item.PIS || 0),

            // 13º Salário
            decimoTerceiro: parseFloat(item.D13 || 0),
            decimoTerceiroFgts: parseFloat(item.D13_FGTS || 0),
            decimoTerceiroPis: parseFloat(item.D13_PIS || 0),

            // Férias
            ferias: parseFloat(item.FERIAS || 0),
            feriasFgts: parseFloat(item.FERIAS_FGTS || 0),
            feriasPis: parseFloat(item.FERIAS_PIS || 0),

            // Outros
            abono: parseFloat(item.ABONO || 0),
            indenizacao: parseFloat(item.INDENIZACAO || 0),

            salariovariavel: parseFloat(item.SALARIOVARIAVEL || 0),

            // Salários mensais (Jan a Dez)
            monthlySalaries: [
              parseFloat(item.JAN || item.SALARIO || 0),
              parseFloat(item.FEV || item.SALARIO || 0),
              parseFloat(item.MAR || item.SALARIO || 0),
              parseFloat(item.ABR || item.SALARIO || 0),
              parseFloat(item.MAI || item.SALARIO || 0),
              parseFloat(item.JUN || item.SALARIO || 0),
              parseFloat(item.JUL || item.SALARIO || 0),
              parseFloat(item.AGO || item.SALARIO || 0),
              parseFloat(item.SET || item.SALARIO || 0),
              parseFloat(item.OUT || item.SALARIO || 0),
              parseFloat(item.NOV || item.SALARIO || 0),
              parseFloat(item.DEZ || item.SALARIO || 0),
              parseFloat(item.SALARIOVARIAVEL || 0),
            ],

            salarioSomar:
              parseFloat(item.JAN) +
              parseFloat(item.FEV) +
              parseFloat(item.MAR) +
              parseFloat(item.ABR) +
              parseFloat(item.MAI) +
              parseFloat(item.JUN) +
              parseFloat(item.JUL) +
              parseFloat(item.AGO) +
              parseFloat(item.SET) +
              parseFloat(item.OUT) +
              parseFloat(item.NOV) +
              parseFloat(item.DEZ) +
              parseFloat(item.SALARIOVARIAVEL),

            // Benefícios (valores padrão - podem ser customizados)
            benefits: {
              healthPlan: 200,
              mealAllowance: 300,
              transport: 180,
            },

            // Dados originais para referência
            originalData: item,
          }));

          setEmployeesData(funcionariosMapeados);
          console.log("✅ Funcionários carregados new :", funcionariosMapeados);
        } else {
          console.log("⚠️ Nenhum funcionário encontrado");
          setEmployeesData([]);
        }
      } catch (error) {
        console.error("❌ Erro ao carregar dados de RH:", error);
        setEmployeesData([]);
      } finally {
        setLoadingEmployees(false);
      }
    },
    [API_BASE_URL]
  );
  //#endregion

  // #region ✅ FUNÇÃO PARA CARREGAR DADOS DE RH*/
  const carregarDadosRHGlobal = useCallback(
    async (centroCusto, ano = localStorage.getItem("selectedYear")) => {
      try {
        setLoadingEmployees(true);
        const token = localStorage.getItem("authToken");
        if (!token) {
          console.error("❌ Token não encontrado");
          return;
        }

        const PCODCOLIGADA = localStorage.getItem("PCODCOLIGADA");
        const PCODFILIAL = localStorage.getItem("PCODFILIAL");

        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };

        // ✅ CONSTRUÇÃO DA WHERE CLAUSE PARA RH
        let whereClause = `AND CODCOLIGADA = '${PCODCOLIGADA}' AND CODFILIAL = '${PCODFILIAL}' AND ANO='${ano}' `;

        console.log("🔍 Carregando dados de RH com WHERE:", whereClause);

        const response = await fetch(
          `${API_BASE_URL}/totvs-sql/sql_MAN_ORC_RH/filter`,
          {
            method: "POST",
            headers,
            body: JSON.stringify({
              WHERE: whereClause,
            }),
          }
        );

        const result = await response.json();
        console.log("📋 Resultado dos dados de RH:", result);

        if (result.success && result.data) {
          // ✅ MAPEAR DADOS DOS FUNCIONÁRIOS
          const funcionariosMapeados = result.data.map((item) => ({
            id: item.CHAPA || item.IDRH,
            name: item.FUNCIONARIO || "N/A",
            position: item.FUNCAO || "N/A",
            salary: parseFloat(item.SALARIO || 0),
            costCenter: item.CENTROCUSTO || "N/A",
            codCostCenter: item.CODCCUSTO || "",
            rateio: parseFloat(item.RATEIO || 100),
            tipoFunc: item.TIPOFUNC || "Normal",

            // Dados de dissídio e mérito
            dissidioMes: item.DISSIOMES || "",
            meritoMes: item.MERITOMES || "",
            merito: parseFloat(item.MERITO || 0),
            dissidio: parseFloat(item.DISSIDIO || 0),

            // Encargos
            fgts: parseFloat(item.FGTS || 0),
            pis: parseFloat(item.PIS || 0),

            // 13º Salário
            decimoTerceiro: parseFloat(item.D13 || 0),
            decimoTerceiroFgts: parseFloat(item.D13_FGTS || 0),
            decimoTerceiroPis: parseFloat(item.D13_PIS || 0),

            // Férias
            ferias: parseFloat(item.FERIAS || 0),
            feriasFgts: parseFloat(item.FERIAS_FGTS || 0),
            feriasPis: parseFloat(item.FERIAS_PIS || 0),

            // Outros
            abono: parseFloat(item.ABONO || 0),
            indenizacao: parseFloat(item.INDENIZACAO || 0),

            salariovariavel: parseFloat(item.SALARIOVARIAVEL || 0),

            // Salários mensais (Jan a Dez)
            monthlySalaries: [
              parseFloat(item.JAN || item.SALARIO || 0),
              parseFloat(item.FEV || item.SALARIO || 0),
              parseFloat(item.MAR || item.SALARIO || 0),
              parseFloat(item.ABR || item.SALARIO || 0),
              parseFloat(item.MAI || item.SALARIO || 0),
              parseFloat(item.JUN || item.SALARIO || 0),
              parseFloat(item.JUL || item.SALARIO || 0),
              parseFloat(item.AGO || item.SALARIO || 0),
              parseFloat(item.SET || item.SALARIO || 0),
              parseFloat(item.OUT || item.SALARIO || 0),
              parseFloat(item.NOV || item.SALARIO || 0),
              parseFloat(item.DEZ || item.SALARIO || 0),
              parseFloat(item.SALARIOVARIAVEL || 0),
            ],

            salarioSomar:
              parseFloat(item.JAN) +
              parseFloat(item.FEV) +
              parseFloat(item.MAR) +
              parseFloat(item.ABR) +
              parseFloat(item.MAI) +
              parseFloat(item.JUN) +
              parseFloat(item.JUL) +
              parseFloat(item.AGO) +
              parseFloat(item.SET) +
              parseFloat(item.OUT) +
              parseFloat(item.NOV) +
              parseFloat(item.DEZ) +
              parseFloat(item.SALARIOVARIAVEL),

            // Benefícios (valores padrão - podem ser customizados)
            benefits: {
              healthPlan: 200,
              mealAllowance: 300,
              transport: 180,
            },

            // Dados originais para referência
            originalData: item,
          }));

          setEmployeesDataGlobal(funcionariosMapeados);
          console.log(
            "✅ Funcionários carregados:",
            funcionariosMapeados.length
          );
        } else {
          console.log("⚠️ Nenhum funcionário encontrado");
          setEmployeesData([]);
        }
      } catch (error) {
        console.error("❌ Erro ao carregar dados de RH:", error);
        setEmployeesDataGlobal([]);
      } finally {
        setLoadingEmployees(false);
      }
    },
    [API_BASE_URL]
  );

  //#endregion

  // #region  ✅ FUNÇÃO PARA SALVAR ALTERAÇÕES NO BANCO
  const salvarAlteracoesFuncionario = async (funcionario) => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) return false;

      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const dadosParaAtualizar = {
        IDRH: funcionario.originalData?.IDRH,
        CHAPA: funcionario.id,
        SALARIO: funcionario.salary,
        MERITO: funcionario.merito || 0,
        DISSIDIO: funcionario.dissidio || 0,
        DISSIOMES: funcionario.dissidioMes || "",
        MERITOMES: funcionario.meritoMes || "",
        JAN: funcionario.monthlySalaries[0],
        FEV: funcionario.monthlySalaries[1],
        MAR: funcionario.monthlySalaries[2],
        ABR: funcionario.monthlySalaries[3],
        MAI: funcionario.monthlySalaries[4],
        JUN: funcionario.monthlySalaries[5],
        JUL: funcionario.monthlySalaries[6],
        AGO: funcionario.monthlySalaries[7],
        SET: funcionario.monthlySalaries[8],
        OUT: funcionario.monthlySalaries[9],
        NOV: funcionario.monthlySalaries[10],
        DEZ: funcionario.monthlySalaries[11],
      };

      const response = await fetch(
        `${API_BASE_URL}/totvs-sql/sql_MAN_ORC_RH/update`,
        {
          method: "PUT",
          headers,
          body: JSON.stringify(dadosParaAtualizar),
        }
      );

      const result = await response.json();
      return result.success;
    } catch (error) {
      console.error("❌ Erro ao salvar alterações:", error);
      return false;
    }
  };
  //#endregion


  // #region  ✅ RECARREGAR QUANDO FILTROS MUDAREM
  useEffect(() => {
    // Só carregar funcionários se um centro de custo específico estiver selecionado
    if (selectedCostCenter && selectedCostCenter !== "") {
      // Buscar o código do centro de custo selecionado
      const centroSelecionado = costCentersData.find(
        (cc) => cc.nome === selectedCostCenter
      );
      const codigoCentro = centroSelecionado
        ? centroSelecionado.codigo
        : selectedCostCenter;

      carregarDadosRH(codigoCentro);
    } else {
      // Limpar dados de funcionários quando nenhum centro estiver selecionado
      setEmployeesData([]);
    }
  }, [selectedCostCenter, carregarDadosRH, costCentersData]);
  //#endregion

  // Usar dados da API ou fallback para dados estáticos
  const employees = employeesData;
  const employeesGlobal = employeesDataGlobal;

  // #region ✅ CENTROS DE CUSTO - USAR DADOS DA API
  // Lista para o select - priorizar dados da API
  const allCostCentersForSelect = costCentersData.map((cc) => cc.nome);



/*const breakdown = employeesDataGlobal.reduce(
  (acc, funcionario) => ({
    salary: acc.salary + funcionario.salary,
    decimoTerceiro: acc.decimoTerceiro + funcionario.decimoTerceiro,
    ferias: acc.ferias + funcionario.ferias,
    fgts: acc.fgts + (funcionario.fgts * 12),
    pis: acc.pis + (funcionario.pis * 12),
    decimoTerceiroFgts: acc.decimoTerceiroFgts + funcionario.decimoTerceiroFgts,
    decimoTerceiroPis: acc.decimoTerceiroPis + funcionario.decimoTerceiroPis,
    feriasFgts: acc.feriasFgts + funcionario.feriasFgts,
    feriasPis: acc.feriasPis + funcionario.feriasPis,
    salariovariavel: acc.salariovariavel + funcionario.salariovariavel,
    abono: acc.abono + funcionario.abono,
    indenizacao: acc.indenizacao + funcionario.indenizacao,
  }),
  {
    salary: 0,
    decimoTerceiro: 0,
    ferias: 0,
    fgts: 0,
    pis: 0,
    decimoTerceiroFgts: 0,
    decimoTerceiroPis: 0,
    feriasFgts: 0,
    feriasPis: 0,
    salariovariavel: 0,
    abono: 0,
    indenizacao: 0,
  }
);

console.table(breakdown);

const TotalSalarioGlobalS = Object.values(breakdown).reduce((sum, val) => sum + val, 0);
console.log('Total:', TotalSalarioGlobalS);*/


  //#endregion

  // #region ✅ FILTRAR FUNCIONÁRIOS - MODIFICAÇÃO PRINCIPAL

  const filteredEmployees = employeesGlobal.filter((emp) => {
    // Só mostrar funcionários se um centro de custo específico estiver selecionado
    if (!selectedCostCenter || selectedCostCenter === "") {
      return false; // Não mostrar nenhum funcionário
    }
    const matchesCostCenter = emp.costCenter === selectedCostCenter;
    const matchesSearch =
      emp.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      emp.position.toLowerCase().includes(searchTerm.toLowerCase()) ||
      emp.id.toString().includes(searchTerm);

    console.log("Filtro" + matchesCostCenter && matchesSearch);

    return matchesCostCenter && matchesSearch;
  });

  //#endregion

  // ✅ ATUALIZAR SALÁRIO MENSAL COM PERSISTÊNCIA
  const updateMonthlySalary = async (employeeId, monthIndex, newValue) => {
    const updatedEmployees = employees.map((emp) => {
      if (emp.id === employeeId) {
        const newMonthlySalaries = [...emp.monthlySalaries];
        newMonthlySalaries[monthIndex] = parseFloat(newValue) || 0;
        const updatedEmployee = { ...emp, monthlySalaries: newMonthlySalaries };

        // Salvar no banco
        salvarAlteracoesFuncionario(updatedEmployee);

        return updatedEmployee;
      }
      return emp;
    });

    setEmployeesData(updatedEmployees);
  };

  // Função para toggle do drill-down
  const toggleDrillDown = (costCenter) => {
    if (expandedCostCenter === costCenter) {
      setExpandedCostCenter("");
    } else {
      setExpandedCostCenter(costCenter);
    }
  };

  // Função para obter funcionários de um centro de custo específico
  const getEmployeesByCostCenter = (costCenter) => {
    return employeesGlobal.filter((emp) => emp.costCenter === costCenter);
  };

  const months = [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez",
  ];

  const tiposFuncionario = ["Estagiario", "Normal", "Jovem Aprendiz"];

  // Função para aplicar dissídio geral
  const aplicarDissidioGeral = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("❌ Token não encontrado");
        toast.error("Usuário não autenticado");
        return;
      }

      // Obter dados do usuário
      const tokenPayload = JSON.parse(atob(token.split(".")[1]));
      const currentUsername = tokenPayload.username || tokenPayload.id;
      const PCODCOLIGADA = localStorage.getItem("PCODCOLIGADA");
      const PCODFILIAL = localStorage.getItem("PCODFILIAL");

      // Preparar payload
      const payload = {
        itens: [
          {
            CODCOLIGADA: PCODCOLIGADA,
            CODFILIAL: PCODFILIAL,
            DISSIDIO: parseFloat(dissidioGeralData.valor.replace(",", ".")),
            DISSIOMES: dissidioGeralData.mes,
            ANO: localStorage.getItem("selectedYear"),
            RECMODIFIEDBY: currentUsername,
            TIPOFUNC: dissidioGeralData.tipo,
          },
        ],
      };

      console.log("Preparar payload novo Dissídio: ", payload);

      const response = await fetch(`${API_BASE_URL}/man_orc_rh`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      console.log(response);

      if (!response.ok) {
        const err = await response.json();
        throw new Error(
          err.message || "Erro ao atualizar o Dissídio contratação"
        );
      }

      alert("Dissídio Atualizado com sucesso!");

      // Fechar modal e limpar dados
      setShowDissidioGeralModal(false);
      setDissidioGeralData({
        mes: "",
        valor: "",
        tipo: "",
      });

      // ✅ RECARREGAR TODOS OS DADOS RELEVANTES
      await Promise.all([
        carregarDadosRHGlobal(), // Dados globais
        carregarDadosRealizadoxOrcado(""), // Dados orçado x realizado
        // Se houver um centro de custo selecionado, recarregar os dados específicos
        selectedCostCenter
          ? (() => {
              const centroSelecionado = costCentersData.find(
                (cc) => cc.nome === selectedCostCenter
              );
              const codigoCentro = centroSelecionado
                ? centroSelecionado.codigo
                : selectedCostCenter;
              return carregarDadosRH(codigoCentro);
            })()
          : Promise.resolve(),
      ]);
    } catch (error) {
      console.error("❌ Erro ao cadastrar Dissídio:", error);
      toast.error(error.message || "Erro de conexão ao cadastrar contratação");
    }
  };
  //#endregion

  // #region Função para aplicar mérito
  const aplicarMerito = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("❌ Token não encontrado");
        toast.error("Usuário não autenticado");
        return;
      }

      // Obter dados do usuário
      const tokenPayload = JSON.parse(atob(token.split(".")[1]));
      const currentUsername = tokenPayload.username || tokenPayload.id;
      const PCODCOLIGADA = localStorage.getItem("PCODCOLIGADA");
      const PCODFILIAL = localStorage.getItem("PCODFILIAL");

      // Preparar payload
      const payload = {
        itens: [
          {
            CODCOLIGADA: PCODCOLIGADA,
            CODFILIAL: PCODFILIAL,
            MERITO: parseFloat(meritoData.valor.replace(",", ".")),
            MERITOMES: meritoData.mes,
            ANO: localStorage.getItem("selectedYear"),
            RECMODIFIEDBY: currentUsername,
            CHAPA: meritoData.chapa,
          },
        ],
      };

      console.log("Preparar payload para Merito: ", payload);

      const response = await fetch(`${API_BASE_URL}/man_orc_rh/merito`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      console.log(response);

      if (!response.ok) {
        const err = await response.json();
        throw new Error(
          err.message || "Erro ao atualizar o Merito contratação"
        );
      }

      alert("Mérito Atualizado com sucesso!");

      // Fechar modais e limpar dados
      setShowMeritoModal(false);
      setSelectedEmployee(null);
      setMeritoData({
        mes: "",
        valor: "",
        chapa: "",
      });

      // ✅ RECARREGAR TODOS OS DADOS RELEVANTES
      await Promise.all([
        carregarDadosRHGlobal(), // Dados globais
        carregarDadosRealizadoxOrcado(""), // Dados orçado x realizado
        // Se houver um centro de custo selecionado, recarregar os dados específicos
        selectedCostCenter
          ? (() => {
              const centroSelecionado = costCentersData.find(
                (cc) => cc.nome === selectedCostCenter
              );
              const codigoCentro = centroSelecionado
                ? centroSelecionado.codigo
                : selectedCostCenter;
              return carregarDadosRH(codigoCentro);
            })()
          : Promise.resolve(),
      ]);
    } catch (error) {
      console.error("❌ Erro ao cadastrar Dissídio:", error);
      toast.error(error.message || "Erro de conexão ao cadastrar Merito");
    }
  };
  //#endregion

  // #region Função para calcular dados do dashboard
  const getDashboardData = () => {
    console.log("Analista Geral", employeesGlobal);

    const totalSalarios = employeesGlobal.reduce(
      (sum, emp) => sum + emp.salary + emp.decimoTerceiro + emp.ferias + emp.salariovariavel ,
      0
    );

    const totalAbono = employeesGlobal.reduce((sum, emp) => sum + emp.abono, 0);

    const totalIndenizacao = employeesGlobal.reduce(
      (sum, emp) => sum + emp.indenizacao,
      0
    );

    const totalEncargos = employeesGlobal.reduce((sum, emp) => {
      return (
        sum +
        emp.fgts * 12 +
        emp.feriasFgts +
        emp.decimoTerceiroFgts +
        emp.pis * 12 +
        emp.feriasPis +
        emp.decimoTerceiroPis
      );
    }, 0);

    const totalBeneficios = 0;

    const dadosPorCentro = {};
    employeesGlobal.forEach((emp) => {
      const centro = emp.costCenter.replace(/"/g, "").trim();
      if (!dadosPorCentro[centro]) {
        dadosPorCentro[centro] = {
          funcionarios: 0,
          salarios: 0,
          encargos: 0,
          beneficios: 0,
          percentual: 0,
        };
      }
      dadosPorCentro[centro].funcionarios++;
      dadosPorCentro[centro].salarios +=
        emp.salary + emp.decimoTerceiro + emp.ferias + emp.salariovariavel;
      dadosPorCentro[centro].encargos +=
        emp.fgts * 12 +
        emp.feriasFgts +
        emp.decimoTerceiroFgts +
        emp.pis * 12 +
        emp.feriasPis +
        emp.decimoTerceiroPis;

      dadosPorCentro[centro].beneficios = 0;
    });

    // Calcular percentuais
    Object.keys(dadosPorCentro).forEach((centro) => {
      dadosPorCentro[centro].percentual = Math.round(
        (dadosPorCentro[centro].salarios / totalSalarios) * 100
      );
    });

    return {
      totalFuncionarios: employeesGlobal.length,
      totalSalarios,
      totalEncargos,
      totalBeneficios,
      dadosPorCentro,
      custoTotalRealizado:
        totalSalarios +
        totalEncargos +
        totalBeneficios +
        totalAbono +
        totalIndenizacao,
      totalAbono,
      totalIndenizacao,
    };
  };
  //#endregion

  // 🔹 Ajuste na função carregarContratacoes para corrigir o loading state
  const carregarContratacoes = useCallback(
    async (centroCusto, ano = localStorage.getItem("selectedYear")) => {
      try {
        setLoadingContratacoes(true); // ✅ Corrigido aqui
        const token = localStorage.getItem("authToken");
        if (!token) {
          console.error("❌ Token não encontrado");
          return;
        }

        const PCODCOLIGADA = localStorage.getItem("PCODCOLIGADA");
        const PCODFILIAL = localStorage.getItem("PCODFILIAL");

        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };

        // ✅ CONSTRUÇÃO DA WHERE CLAUSE PARA RH
        let whereClause = ` AND CODCOLIGADA = '${PCODCOLIGADA}' AND CODFILIAL = '${PCODFILIAL}' AND ANO = '${localStorage.getItem(
          "selectedYear"
        )}'`;

        console.log("🔍 Carregando dados de RH com WHERE:", whereClause);

        const response = await fetch(
          `${API_BASE_URL}/totvs-sql/sql_MAN_ORC_RH3/filter`,
          {
            method: "POST",
            headers,
            body: JSON.stringify({
              WHERE: whereClause,
            }),
          }
        );

        const result = await response.json();
        console.log("📋 Resultado dos dados de RH: sql_MAN_ORC_RH3", result);

        if (result.success && result.data) {
          const Mapeados = result.data.map((item) => ({
            id: item.ID || item.ID,
            codccusto: item.CODCCUSTO || "N/A",
            nome: item.NOME || "N/A",
            vaga: item.VAGA || "N/A",
            salario: parseFloat(item.SALARIO || 0),
            originalData: item,
          }));

          setContratacoesCadastradas(Mapeados);
          console.log("✅ Funcionários carregados:", Mapeados.length);
        } else {
          console.log("⚠️ Nenhum funcionário encontrado");
          setContratacoesCadastradas([]);
        }
      } catch (error) {
        console.error("❌ Erro ao carregar dados de RH:", error);
        setContratacoesCadastradas([]);
      } finally {
        setLoadingContratacoes(false);
      }
    },
    [API_BASE_URL]
  );

// No componente, fora da função carregarContratacoes
const totalSalariosContratacoes = useMemo(() => {
  if (!contratacoesCadastradas || contratacoesCadastradas.length === 0) {
    return 0; // ✅ Retorna 0 se não houver dados
  }
  return contratacoesCadastradas.reduce(
    (total, funcionario) => total + (parseFloat(funcionario.salario) || 0),
    0
  );
}, [contratacoesCadastradas]);

// Contagem de funcionários novos
const totalFuncionariosNovos = useMemo(() => {
  if (!contratacoesCadastradas || contratacoesCadastradas.length === 0) {
    return 0;
  }
  return contratacoesCadastradas.length;
}, [contratacoesCadastradas]);



console.log("💰 totalSalariosContratacoes:", totalSalariosContratacoes);
console.log("📊 Tipo de totalSalariosContratacoes:", typeof totalSalariosContratacoes);
console.log("✅ É número válido?", !isNaN(totalSalariosContratacoes));

console.log("✅ É número contracao?", !isNaN(totalFuncionariosNovos));


  const TotalSalarioGlobal = employeesDataGlobal.reduce(
    (acumulador, funcionario) =>
      acumulador +
      funcionario.salary +
      funcionario.decimoTerceiro +
      funcionario.ferias +
      (funcionario.fgts * 12) +
      (funcionario.pis * 12) +
      funcionario.decimoTerceiroFgts +
      funcionario.decimoTerceiroPis +
      funcionario.feriasFgts +
      funcionario.feriasPis + 
      funcionario.salariovariavel + 
      funcionario.abono + 
      funcionario.indenizacao,
    0
  );

// Use assim:
console.log("💰 totalSalariosContratacoes :", totalSalariosContratacoes);


  // 🔹 Função para cadastrar nova contratação
  const cadastrarNovaContratacao = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("❌ Token não encontrado");
        toast.error("Usuário não autenticado");
        return;
      }

      // Obter dados do usuário
      const tokenPayload = JSON.parse(atob(token.split(".")[1]));
      const currentUsername = tokenPayload.username || tokenPayload.id;

      const PCODCOLIGADA = localStorage.getItem("PCODCOLIGADA");
      const PCODFILIAL = localStorage.getItem("PCODFILIAL");

      // Validações
      if (
        !novaContratacao.area ||
        !novaContratacao.vaga ||
        !novaContratacao.salario
      ) {
        toast.error("Preencha todos os campos obrigatórios");
        return;
      }
      if (parseFloat(novaContratacao.salario) <= 0) {
        toast.error("O salário deve ser maior que zero");
        return;
      }

      setLoadingContratacoes(true);

      // Preparar payload
      const payload = {
        itens: [
          {
            CODCOLIGADA: PCODCOLIGADA,
            CODFILIAL: PCODFILIAL,
            CODCCUSTO: novaContratacao.area,
            VAGA: novaContratacao.vaga,
            SALARIO: parseFloat(novaContratacao.salario),
            RECCREATEDBY: currentUsername,
            RECCREATEDON: new Date().toISOString(),
            RECMODIFIEDBY: currentUsername,
            RECMODIFIEDON: new Date().toISOString(),
            ANO: localStorage.getItem("selectedYear"),
          },
        ],
      };

      console.log("Preparar payload nova contratacao: ", payload);

      const response = await fetch(`${API_BASE_URL}/man_orc_novocont`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      console.log(response);

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message || "Erro ao cadastrar contratação");
      }

      // sucesso
      toast.success("Contratação cadastrada com sucesso!");
      setNovaContratacao({ area: "", vaga: "", salario: "" });
      await carregarContratacoes();
    } catch (error) {
      console.error("❌ Erro ao cadastrar contratação:", error);
      toast.error(error.message || "Erro de conexão ao cadastrar contratação");
    } finally {
      setLoadingContratacoes(false);
      setLoadingEmployees(false);
    }
  };

  // 🔹 Função para atualizar contratação (corrigida)
  const atualizarContratacao = async (id, dadosAtualizados) => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("❌ Token não encontrado");
        toast.error("Usuário não autenticado");
        return false;
      }

      // Obter dados do usuário
      const tokenPayload = JSON.parse(atob(token.split(".")[1]));
      const currentUsername = tokenPayload.username || tokenPayload.id;

      // Validações
      if (
        !dadosAtualizados.area ||
        !dadosAtualizados.vaga ||
        !dadosAtualizados.salario
      ) {
        toast.error("Preencha todos os campos obrigatórios");
        return false;
      }
      if (parseFloat(dadosAtualizados.salario) <= 0) {
        toast.error("O salário deve ser maior que zero");
        return false;
      }

      setLoadingContratacoes(true);

      const payload = {
        itens: [
          {
            id: id,
            CODCOLIGADA:
              dadosAtualizados.CODCOLIGADA ||
              localStorage.getItem("PCODCOLIGADA"),
            CODFILIAL:
              dadosAtualizados.CODFILIAL || localStorage.getItem("PCODFILIAL"),
            CODCCUSTO: dadosAtualizados.area,
            VAGA: dadosAtualizados.vaga,
            SALARIO: parseFloat(dadosAtualizados.salario),
            RECMODIFIEDBY: currentUsername,
            RECMODIFIEDON: new Date().toISOString(),
          },
        ],
      };

      console.log("Payload para atualização:", payload);

      const response = await fetch(`${API_BASE_URL}/man_orc_novocont`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || "Erro ao atualizar contratação");
      }

      toast.success("Contratação atualizada com sucesso!");
      await carregarContratacoes(); // Recarregar lista
      return true;
    } catch (error) {
      console.error("❌ Erro ao atualizar contratação:", error);
      toast.error(error.message || "Erro de conexão ao atualizar contratação");
      return false;
    } finally {
      setLoadingContratacoes(false);
    }
  };

  // 🔹 Função para deletar contratação (corrigida)
  const deletarContratacao = async (id) => {
    if (
      !window.confirm(
        "⚠️ Tem certeza que deseja EXCLUIR esta contratação?\n\nEsta ação não poderá ser desfeita!"
      )
    ) {
      return false;
    }

    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("❌ Token não encontrado");
        toast.error("Usuário não autenticado");
        return false;
      }

      setLoadingContratacoes(true);

      const payload = {
        itens: [{ id: id }],
      };

      console.log("Payload para exclusão:", payload);

      const response = await fetch(`${API_BASE_URL}/man_orc_novocont`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || "Erro ao excluir contratação");
      }

      toast.success("Contratação excluída com sucesso!");
      await carregarContratacoes(); // Recarregar lista
      return true;
    } catch (error) {
      console.error("❌ Erro ao excluir contratação:", error);
      toast.error(error.message || "Erro de conexão ao excluir contratação");
      return false;
    } finally {
      setLoadingContratacoes(false);
    }
  };

  // 🔹 Função para carregar treinamentos da API
  const carregarTreinamentos = useCallback(
    async (centroCusto, ano = localStorage.getItem("selectedYear")) => {
      try {
        setLoadingTreinamentos(true);
        const token = localStorage.getItem("authToken");
        if (!token) {
          console.error("❌ Token não encontrado");
          return;
        }

        const PCODCOLIGADA = localStorage.getItem("PCODCOLIGADA") || " ";
        const PCODFILIAL = localStorage.getItem("PCODFILIAL") || " ";

        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };

        let whereClause = ` AND CODCOLIGADA = '${PCODCOLIGADA}' AND CODFILIAL = '${PCODFILIAL}' and ANO = ${localStorage.getItem(
          "selectedYear"
        )}`;

        console.log("🔍 Carregando dados de treinamentos:", whereClause);

        const response = await fetch(
          `${API_BASE_URL}/totvs-sql/sql_MAN_ORC_RH4/filter`,
          {
            method: "POST",
            headers,
            body: JSON.stringify({
              WHERE: whereClause,
            }),
          }
        );

        const result = await response.json();
        console.log("📋 Resultado dos dados de treinamentos:", result);

        if (result.success && result.data) {
          const treinamentosMapeados = result.data.map((item) => ({
            id: item.id || item.id,
            codccusto: item.CODCCUSTO || "N/A",
            centrocusto: item.NOME || "N/A",
            curso: item.CURSO || "N/A",
            participante: parseInt(item.PARTICIPANTE || 0),
            duracao: parseFloat(item.DURACAO || 0),
            valor: parseFloat(item.VALOR || 0),
            originalData: item,
          }));

          setTreinamentosCadastrados(treinamentosMapeados);
          console.log(
            "✅ Treinamentos carregados:",
            treinamentosMapeados.length
          );
        } else {
          console.log("⚠️ Nenhum treinamento encontrado");
          setTreinamentosCadastrados([]);
        }
      } catch (error) {
        console.error("❌ Erro ao carregar dados de treinamentos:", error);
        setTreinamentosCadastrados([]);
      } finally {
        setLoadingTreinamentos(false);
      }
    },
    [API_BASE_URL]
  );

  // 🔹 Função para cadastrar novo treinamento
  const cadastrarNovoTreinamento = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("❌ Token não encontrado");
        alert("Usuário não autenticado");
        return;
      }

      const tokenPayload = JSON.parse(atob(token.split(".")[1]));
      const currentUsername = tokenPayload.username || tokenPayload.id;

      const PCODCOLIGADA = localStorage.getItem("PCODCOLIGADA") || " ";
      const PCODFILIAL = localStorage.getItem("PCODFILIAL") || " ";

      // Validações
      if (
        !novoTreinamento.centrocusto ||
        !novoTreinamento.curso ||
        !novoTreinamento.participante ||
        !novoTreinamento.duracao ||
        !novoTreinamento.valor
      ) {
        alert("Preencha todos os campos obrigatórios");
        return;
      }
      if (parseFloat(novoTreinamento.valor) <= 0) {
        alert("O valor deve ser maior que zero");
        return;
      }
      if (parseInt(novoTreinamento.participante) <= 0) {
        alert("O número de participantes deve ser maior que zero");
        return;
      }

      setLoadingTreinamentos(true);

      const payload = {
        itens: [
          {
            CODCOLIGADA: PCODCOLIGADA,
            CODFILIAL: PCODFILIAL,
            CODCCUSTO: novoTreinamento.centrocusto,
            CURSO: novoTreinamento.curso,
            PARTICIPANTE: parseInt(novoTreinamento.participante),
            DURACAO: parseFloat(novoTreinamento.duracao),
            VALOR: parseFloat(novoTreinamento.valor),
            RECCREATEDBY: currentUsername,
            RECCREATEDON: new Date().toISOString(),
            RECMODIFIEDBY: currentUsername,
            RECMODIFIEDON: new Date().toISOString(),
            ANO: localStorage.getItem("selectedYear"),
          },
        ],
      };

      console.log("Payload novo treinamento:", payload);

      const response = await fetch(`${API_BASE_URL}/man_orc_novotrain`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message || "Erro ao cadastrar treinamento");
      }

      alert("Treinamento cadastrado com sucesso!");
      setNovoTreinamento({
        centrocusto: "",
        curso: "",
        participante: "",
        duracao: "",
        valor: "",
      });
      await carregarTreinamentos();
    } catch (error) {
      console.error("❌ Erro ao cadastrar treinamento:", error);
      alert(error.message || "Erro de conexão ao cadastrar treinamento");
    } finally {
      setLoadingTreinamentos(false);
    }
  };

  // 🔹 Função para atualizar treinamento
  const atualizarTreinamento = async (id, dadosAtualizados) => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("❌ Token não encontrado");
        alert("Usuário não autenticado");
        return false;
      }

      const tokenPayload = JSON.parse(atob(token.split(".")[1]));
      const currentUsername = tokenPayload.username || tokenPayload.id;

      // Validações
      if (
        !dadosAtualizados.centrocusto ||
        !dadosAtualizados.curso ||
        !dadosAtualizados.participante ||
        !dadosAtualizados.duracao ||
        !dadosAtualizados.valor
      ) {
        alert("Preencha todos os campos obrigatórios");
        return false;
      }
      if (parseFloat(dadosAtualizados.valor) <= 0) {
        alert("O valor deve ser maior que zero");
        return false;
      }
      if (parseInt(dadosAtualizados.participante) <= 0) {
        alert("O número de participantes deve ser maior que zero");
        return false;
      }

      setLoadingTreinamentos(true);

      const payload = {
        itens: [
          {
            id: id,
            CODCOLIGADA:
              dadosAtualizados.CODCOLIGADA ||
              localStorage.getItem("PCODCOLIGADA"),
            CODFILIAL:
              dadosAtualizados.CODFILIAL || localStorage.getItem("PCODFILIAL"),
            CODCCUSTO: dadosAtualizados.centrocusto,
            CURSO: dadosAtualizados.curso,
            PARTICIPANTE: parseInt(dadosAtualizados.participante),
            DURACAO: parseFloat(dadosAtualizados.duracao),
            VALOR: parseFloat(dadosAtualizados.valor),
            RECMODIFIEDBY: currentUsername,
            RECMODIFIEDON: new Date().toISOString(),
          },
        ],
      };

      console.log("Payload para atualização treinamento:", payload);

      const response = await fetch(`${API_BASE_URL}/man_orc_novotrain`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || "Erro ao atualizar treinamento");
      }

      alert("Treinamento atualizado com sucesso!");
      await carregarTreinamentos();
      return true;
    } catch (error) {
      console.error("❌ Erro ao atualizar treinamento:", error);
      alert(error.message || "Erro de conexão ao atualizar treinamento");
      return false;
    } finally {
      setLoadingTreinamentos(false);
    }
  };

  // 🔹 Função para deletar treinamento
  const deletarTreinamento = async (id) => {
    if (
      !window.confirm(
        "⚠️ Tem certeza que deseja EXCLUIR este treinamento?\n\nEsta ação não poderá ser desfeita!"
      )
    ) {
      return false;
    }

    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("❌ Token não encontrado");
        alert("Usuário não autenticado");
        return false;
      }

      setLoadingTreinamentos(true);

      const payload = {
        itens: [{ id: id }],
      };

      console.log("Payload para exclusão treinamento:", payload);

      const response = await fetch(`${API_BASE_URL}/man_orc_novotrain`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || "Erro ao excluir treinamento");
      }

      alert("Treinamento excluído com sucesso!");
      await carregarTreinamentos();
      return true;
    } catch (error) {
      console.error("❌ Erro ao excluir treinamento:", error);
      alert(error.message || "Erro de conexão ao excluir treinamento");
      return false;
    } finally {
      setLoadingTreinamentos(false);
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);
  };

  // Carregar dados quando a aba mudar
  useEffect(() => {
    if (activeTab === "treinamento") {
      carregarTreinamentos();
    }
  }, [activeTab, carregarTreinamentos]);

  // Adicione no seu useEffect principal para carregar os dados quando o componente montar
  /*useEffect(() => {
    if (activeTab === "novas") {
      carregarContratacoes();
    }
  }, [activeTab]);*/

  // Componente de Modal de Salário
  const SalaryModal = () => {
    if (!selectedEmployee) return null;

    const monthlySalary = selectedEmployee.salary;
    const thirteenthSalary = selectedEmployee.decimoTerceiro;
    const ferias = selectedEmployee.ferias;
    const SalVariavel = selectedEmployee.salariovariavel;

    const totalAnnual = monthlySalary + thirteenthSalary + ferias + SalVariavel;

    return (
      <div
        className="modal show d-block"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                💰 Detalhamento Salarial - {selectedEmployee.name}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowSalaryModal(false)}
              ></button>
            </div>
            <div className="modal-body">
              {/* Primeira linha - 4 cards principais */}
              <div className="row g-3 mb-4">
                <div className="col-md-3">
                  <div className="card bg-light shadow-sm h-100">
                    <div className="card-body text-center">
                      <h6 className="card-title text-muted mb-3">
                        Salário Anual
                      </h6>
                      <h5 className="text-primary fw-bold">
                        {formatCurrency(monthlySalary)}
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card bg-light shadow-sm h-100">
                    <div className="card-body text-center">
                      <h6 className="card-title text-muted mb-3">
                        Salário Variável
                      </h6>
                      <h5 className="text-primary fw-bold">
                        {formatCurrency(SalVariavel)}
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card bg-light shadow-sm h-100">
                    <div className="card-body text-center">
                      <h6 className="card-title text-muted mb-3">1/3 Férias</h6>
                      <h5 className="text-success fw-bold">
                        {formatCurrency(ferias)}
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card bg-light shadow-sm h-100">
                    <div className="card-body text-center">
                      <h6 className="card-title text-muted mb-3">
                        13º Salário
                      </h6>
                      <h5 className="text-success fw-bold">
                        {formatCurrency(thirteenthSalary)}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>

              {/* Segunda linha - Total em destaque */}
              <div className="row">
                <div className="col-12">
                  <div className="card bg-light  bg-opacity-10 border-warning shadow">
                    <div className="card-body text-center py-4">
                      <h5 className="card-title text-muted mb-3">
                        Total Anual
                      </h5>
                      <h3 className="text-warning fw-bold mb-0">
                        {formatCurrency(totalAnnual)}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const ChargesModal = () => {
    if (!selectedEmployee) return null;

    const fgts =
      selectedEmployee.fgts * 12 +
      selectedEmployee.feriasFgts +
      selectedEmployee.decimoTerceiroFgts; //calculateFGTS(salary);
    const pis =
      selectedEmployee.pis * 12 +
      selectedEmployee.feriasPis +
      selectedEmployee.decimoTerceiroPis;
    const totalCharges = fgts + pis;

    return (
      <div
        className="modal show d-block"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                📊 Encargos Sociais - {selectedEmployee.name}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowChargesModal(false)}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-4">
                  <div className="card bg-light">
                    <div className="card-body text-center">
                      <h6 className="card-title">FGTS (8%)</h6>
                      <h5 className="text-success">{formatCurrency(fgts)}</h5>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card bg-light">
                    <div className="card-body text-center">
                      <h6 className="card-title">PIS (1%)</h6>
                      <h5 className="text-info">{formatCurrency(pis)}</h5>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card bg-light">
                    <div className="card-body text-center">
                      <h6 className="card-title">Total</h6>
                      <h5 className="text-danger">
                        {formatCurrency(totalCharges)}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Componente de Modal de Dissídio Geral
  // Componente de Modal de Dissídio Geral - CORRIGIDO
  // Componente de Modal de Dissídio Geral - CORRIGIDO
  const DissidioGeralModal = () => {
    return (
      <div
        className="modal show d-block"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header bg-warning text-dark">
              <h5 className="modal-title">📈 Aplicar Dissídio Geral</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowDissidioGeralModal(false)}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-3">
                  <label className="form-label fw-bold">Mês de Aplicação</label>
                  <select
                    className="form-select"
                    value={dissidioGeralData.mes}
                    onChange={(e) =>
                      setDissidioGeralData({
                        ...dissidioGeralData,
                        mes: e.target.value,
                      })
                    }
                  >
                    <option value="">Selecione o mês</option>
                    {months.map((month, index) => (
                      <option key={month} value={index + 1}>
                        {month}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <label className="form-label fw-bold">Percentual (%)</label>
                  <input
                    type="text" // ✅ MUDADO: voltando para text para maior liberdade
                    className="form-control"
                    placeholder="Ex: 5.5"
                    defaultValue={dissidioGeralData.valor}
                    onBlur={(e) =>
                      setDissidioGeralData({
                        ...dissidioGeralData,
                        valor: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label fw-bold">Tipo Funcionário</label>
                  <select
                    className="form-select"
                    value={dissidioGeralData.tipo}
                    onChange={(e) =>
                      setDissidioGeralData({
                        ...dissidioGeralData,
                        tipo: e.target.value,
                      })
                    }
                  >
                    <option value="">Todos os tipos</option>
                    {tiposFuncionario.map((tipo) => (
                      <option key={tipo} value={tipo}>
                        {tipo}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <label className="form-label fw-bold">
                    Total Funcionários
                  </label>
                  <div className="form-control bg-light">
                    <strong>{employeesGlobal.length}</strong> funcionários
                  </div>
                </div>
              </div>

              {dissidioGeralData.valor && (
                <div className="row mt-4">
                  <div className="col-12">
                    <div className="alert alert-info">
                      <h6>📊 Simulação do Impacto:</h6>
                      <p className="mb-1">
                        <strong>Valor Folha: Anual </strong>
                        {formatCurrency(getDashboardData().totalSalarios)}
                        <strong> Mensal:</strong>{" "}
                        {formatCurrency(getDashboardData().totalSalarios / 12)}
                      </p>
                      <p className="mb-1">
                        <strong>Percentual:</strong> {dissidioGeralData.valor}%
                      </p>
                      <p className="mb-1">
                        <strong>Impacto Mensal:</strong>{" "}
                        {formatCurrency(
                          (getDashboardData().totalSalarios / 12) *
                            ((parseFloat(
                              dissidioGeralData.valor.replace(",", ".")
                            ) || 0) /
                              100)
                        )}
                      </p>
                      <p className="mb-1">
                        <strong>Impacto Anual:</strong>{" "}
                        {formatCurrency(
                          getDashboardData().totalSalarios *
                            ((parseFloat(
                              dissidioGeralData.valor.replace(",", ".")
                            ) || 0) /
                              100)
                        )}
                      </p>
                      <p className="mb-1">
                        <strong>⚠️ Valor com Dissídio:</strong>
                      </p>
                      <p className="mb-1">
                        <strong>Valor Mensal:</strong>{" "}
                        {formatCurrency(
                          getDashboardData().totalSalarios / 12 +
                            (getDashboardData().totalSalarios / 12) *
                              ((parseFloat(
                                dissidioGeralData.valor.replace(",", ".")
                              ) || 0) /
                                100)
                        )}
                      </p>
                      <p className="mb-0">
                        <strong>Valor Anual:</strong>{" "}
                        {formatCurrency(
                          getDashboardData().totalSalarios +
                            getDashboardData().totalSalarios *
                              ((parseFloat(
                                dissidioGeralData.valor.replace(",", ".")
                              ) || 0) /
                                100)
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setShowDissidioGeralModal(false)}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-warning"
                onClick={aplicarDissidioGeral}
                disabled={!dissidioGeralData.tipo}
              >
                📈 Aplicar Dissídio Geral
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Componente de Modal de Mérito
  const MeritoModal = () => {
    if (!selectedEmployee) return null;

    return (
      <div
        className="modal show d-block"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                🏆 Aplicar Mérito - {selectedEmployee.name}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowMeritoModal(false)}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-4">
                  <label className="form-label">Mês</label>
                  <select
                    className="form-select"
                    value={meritoData.mes}
                    onChange={(e) =>
                      setMeritoData({
                        ...meritoData,
                        mes: e.target.value,
                        chapa: selectedEmployee.id,
                      })
                    }
                  >
                    <option value="">Selecione o mês</option>
                    {months.map((month, index) => (
                      <option key={month} value={index + 1}>
                        {month}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4">
                  <label className="form-label">Valor do Aumento (R$)</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Ex: 10.0"
                    defaultValue={meritoData.valor}
                    onBlur={(e) =>
                      setMeritoData({ ...meritoData, valor: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setShowMeritoModal(false)}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={aplicarMerito}
              >
                Aplicar Mérito
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  /* RH - BENEFICIOS */

  // ADICIONE ESTES ESTADOS NO INÍCIO DO COMPONENTE (junto com os outros useState)
  const [cenarioData, setCenarioData] = useState({
    ano: localStorage.getItem("selectedYear") || "2025",
    totalFuncionarios: 0,
    totalSalarios: 0,
    totalEncargos: 0,
    totalBeneficios: 0,
    redutor: 0,
    totalRH: 0,
    mediaBeneficios: 0,
    totalAbono: 0,
    totalIndenizacao: 0,
  });
  const [loadingCenario, setLoadingCenario] = useState(false);

  // FUNÇÃO PARA CARREGAR DADOS DO CENÁRIO DA API
  const carregarDadosCenario = async (
    ano = localStorage.getItem("selectedYear")
  ) => {
    try {
      setLoadingCenario(true);
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("❌ Token não encontrado");
        return;
      }

      const PCODCOLIGADA = localStorage.getItem("PCODCOLIGADA");
      const PCODFILIAL = localStorage.getItem("PCODFILIAL");

      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      // ✅ CONSTRUÇÃO DA WHERE CLAUSE PARA CENÁRIO
      let whereClause = `AND CODCOLIGADA = '${PCODCOLIGADA}' AND CODFILIAL = '${PCODFILIAL}' AND ANO = '${ano}'`;

      console.log("🔍 Carregando dados do cenário com WHERE:", whereClause);

      const response = await fetch(
        `${API_BASE_URL}/totvs-sql/sql_MAN_ORC_RH2/filter`,
        {
          method: "POST",
          headers,
          body: JSON.stringify({
            WHERE: whereClause,
          }),
        }
      );

      const result = await response.json();
      console.log("📋 Resultado dos dados do cenário:", result);

      if (result.success && result.data && result.data.length > 0) {
        // ✅ PEGAR O PRIMEIRO REGISTRO (ou somar se houver múltiplos)
        const dadosConsolidados = result.data.reduce(
          (acc, item) => ({
            ano: item.ANO || ano,
            totalFuncionarios:
              acc.totalFuncionarios + (parseInt(item.TOTAL_FUNC) || 0),
            totalSalarios: acc.totalSalarios + (parseFloat(item.SALARIO) || 0),
            totalEncargos: acc.totalEncargos + (parseFloat(item.ENCARGOS) || 0),
            totalBeneficios:
              acc.totalBeneficios + (parseFloat(item.BENEFICIOS) || 0),
            redutor: acc.redutor + (parseFloat(item.REDUTOR) || 0),
            totalRH: acc.totalRH + (parseFloat(item.TOTAL_RH) || 0),
            mediaBeneficios:
              acc.mediaBeneficios + (parseFloat(item.MEDIA_BENEFICIOS) || 0),

            totalAbono:
              acc.totalAbono +
              (parseFloat(item.ABONO) ||
                0) /*+ (parseFloat(item.ABONO) || 0),*/,
            totalIndenizacao:
              acc.totalIndenizacao + (parseFloat(item.INDENIZACAO) || 0),
          }),
          {
            ano: ano,
            totalFuncionarios: 0,
            totalSalarios: 0,
            totalEncargos: 0,
            totalBeneficios: 0,
            redutor: 0,
            totalRH: 0,
            mediaBeneficios: 0,
            totalAbono: 0,
            totalIndenizacao: 0,
          }
        );

        // Se há múltiplos registros, calcular a média dos benefícios
        if (result.data.length > 1) {
          dadosConsolidados.mediaBeneficios =
            dadosConsolidados.mediaBeneficios / result.data.length;
        }

        setCenarioData(dadosConsolidados);
        console.log("✅ Dados do cenário carregados:", dadosConsolidados);
      } else {
        console.log("⚠️ Nenhum dado de cenário encontrado");
        // Manter dados zerados mas com o ano atual
        setCenarioData({
          ano: ano,
          totalFuncionarios: 0,
          totalSalarios: 0,
          totalEncargos: 0,
          totalBeneficios: 0,
          redutor: 0,
          totalRH: 0,
          mediaBeneficios: 0,
          totalAbono: 0,
          totalIndenizacao: 0,
        });
      }
    } catch (error) {
      console.error("❌ Erro ao carregar dados do cenário:", error);
      // Em caso de erro, manter estrutura vazia
      setCenarioData({
        ano: ano,
        totalFuncionarios: 0,
        totalSalarios: 0,
        totalEncargos: 0,
        totalBeneficios: 0,
        redutor: 0,
        totalRH: 0,
        mediaBeneficios: 0,
        totalAbono: 0,
        totalIndenizacao: 0,
      });
    } finally {
      setLoadingCenario(false);
    }
  };

  // FUNÇÃO PARA OBTER OS DADOS DO CENÁRIO (simplificada)
  const getCenarioData = () => {
    return cenarioData;
  };

  // ADICIONE ESTE useEffect PARA CARREGAR OS DADOS AUTOMATICAMENTE
  useEffect(() => {
    carregarDadosCenario();
  }, [API_BASE_URL]);

    // ✅ CARREGAR DADOS AO MONTAR O COMPONENTE
  useEffect(() => {
    carregarCentrosCusto();
    carregarDadosRHGlobal();
    // ⚠️ `carregarDadosRealizadoxOrcado("")` saiu daqui: o useEffect da linha
    // ~159 já faz exatamente esta chamada no mount, com o mesmo argumento
    // (`selectedCostCenterFilter` é useState("") sem setter, então nunca muda).
    // Eram duas execuções da sql_MAN_ORC_RH1, que sozinha leva ~3s no banco —
    // elas se atropelavam e o log do backend registrava 19,8s.
    carregarContratacoes();
  }, [carregarCentrosCusto, carregarDadosRealizadoxOrcado, carregarContratacoes]);



  return (
    <div
      className="container-fluid"
      style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}
    >
      {/* Header */}
      <div className="row py-3">
        <div className="col-12 text-center">
          <h2
            className="text-dark fw-semibold mb-4"
            style={{ fontSize: "2.20rem" }}
          >
            🧑‍💻 Planejamento Orçamentário de Recursos Humanos
          </h2>
          <span className="text-dark fw-semibold mb-4">
            <h3>
              {localStorage.getItem("selectedYear")} -{" "}
              {localStorage.getItem("NomeFilial")}{" "}
            </h3>
          </span>
        </div>
      </div>
      {/* Navigation Tabs */}
      <div className="row mb-4">
        <div className="col-12">
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "salarios" ? "active" : ""
                }`}
                onClick={() => setActiveTab("salarios")}
              >
                💰 Salários e Encargos
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "novas" ? "active" : ""}`}
                onClick={() => setActiveTab("novas")}
              >
                👥 Novas Contratações
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "treinamento" ? "active" : ""
                }`}
                onClick={() => setActiveTab("treinamento")}
              >
                🎓 Treinamento e Desenvolvimento
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "realizado" ? "active" : ""
                }`}
                onClick={() => setActiveTab("Orcamento")}
              >
                📊 Orçamento Geral
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "cenario" ? "active" : ""
                }`}
                onClick={() => setActiveTab("cenario")}
              >
                🎁 Orçamento Geral + Benefícios
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "realizado" ? "active" : ""
                }`}
                onClick={() => setActiveTab("orcado-realizado")}
              >
                💼 Orçado vs Realizado
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Aba Salários */}
      {activeTab === "salarios" && (
        <div className="row">
          {/* Filtros */}
          <div className="col-md-3">
            <div className="card border-0 shadow-sm">
              <div className="card-header">
                <h6 className="card-title mb-0">🔍 Filtros</h6>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <label className="form-label">Centro de Custo</label>
                  <select
                    className="form-select"
                    value={selectedCostCenter}
                    onChange={(e) => setSelectedCostCenter(e.target.value)}
                    disabled={loadingCostCenters}
                  >
                    <option value="">
                      {loadingCostCenters
                        ? "Carregando..."
                        : "Selecione um centro de custo"}
                    </option>
                    {allCostCentersForSelect.map((center) => (
                      <option key={center} value={center}>
                        {center}
                      </option>
                    ))}
                  </select>
                  {loadingCostCenters && (
                    <small className="text-muted">
                      <div
                        className="spinner-border spinner-border-sm me-1"
                        role="status"
                      ></div>
                      Carregando centros de custo...
                    </small>
                  )}
                  {!selectedCostCenter && !loadingCostCenters && (
                    <small className="text-info">
                      💡 Selecione um centro de custo para ver os funcionários
                    </small>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">Buscar</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Nome, função ou chapa..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    disabled={!selectedCostCenter}
                  />
                </div>
                <div className="d-grid mb-3">
                  <button
                    className={`btn ${
                      showMonthlyEvolution
                        ? "btn-warning"
                        : "btn-outline-primary"
                    }`}
                    onClick={() =>
                      setShowMonthlyEvolution(!showMonthlyEvolution)
                    }
                    disabled={loadingEmployees || !selectedCostCenter}
                  >
                    📅 {showMonthlyEvolution ? "Ocultar" : "Mostrar"} Evolução
                    Mensal
                  </button>
                </div>
                <div className="d-grid mb-3">
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => {
                      carregarCentrosCusto();
                      if (selectedCostCenter) {
                        const centroSelecionado = costCentersData.find(
                          (cc) => cc.nome === selectedCostCenter
                        );
                        const codigoCentro = centroSelecionado
                          ? centroSelecionado.codigo
                          : selectedCostCenter;
                        carregarDadosRH(codigoCentro);
                      }
                    }}
                    disabled={loadingEmployees || loadingCostCenters}
                  >
                    {loadingEmployees || loadingCostCenters ? (
                      <>
                        <div
                          className="spinner-border spinner-border-sm me-1"
                          role="status"
                        ></div>
                        Carregando...
                      </>
                    ) : (
                      <>🔄 Atualizar Dados</>
                    )}
                  </button>
                </div>
                <div className="d-grid">
                  <button
                    className="btn btn-warning"
                    onClick={() => setShowDissidioGeralModal(true)}
                  >
                    📈 Aplicar Dissídio Geral
                  </button>
                </div>

                {/* Card de Resumo do Centro de Custo Selecionado */}
                {selectedCostCenter && filteredEmployees.length > 0 && (
                  <div className="mt-4">
                    <div className="card border-0 shadow-sm bg-light">
                      <div className="card-header bg-primary text-white">
                        <h6 className="card-title mb-0">
                          📊 <b className="text-dark">(Anual)</b> Resumo Geral{" "}
                        </h6>
                      </div>
                      <div className="card-body p-2">
                        <div className="row g-2">
                          <div className="col-6">
                            <div className="text-center p-2 bg-white rounded">
                              <small className="text-muted d-block">
                                Funcionários
                              </small>
                              <strong className="text-primary fs-5">
                                {filteredEmployees.length}
                              </strong>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="text-center p-2 bg-white rounded">
                              <small className="text-muted d-block">
                                Total Salários
                              </small>
                              <strong className="text-success fs-6">
                                {formatCurrency(
                                  filteredEmployees.reduce(
                                    (sum, emp) =>
                                      sum +
                                      emp.salary +
                                      emp.decimoTerceiro +
                                      emp.ferias +
                                      emp.salariovariavel,
                                    0
                                  )
                                )}
                              </strong>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="text-center p-2 bg-white rounded">
                              <small className="text-muted d-block">
                                Total Encargos
                              </small>
                              <strong className="text-info fs-6">
                                {formatCurrency(
                                  filteredEmployees.reduce((sum, emp) => {
                                    return (
                                      sum +
                                      (emp.fgts * 12) +
                                      emp.feriasFgts +
                                      emp.decimoTerceiroFgts +
                                      (emp.pis * 12) +
                                      emp.feriasPis +
                                      emp.decimoTerceiroPis
                                    );
                                  }, 0)
                                )}
                              </strong>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="text-center p-2 bg-white rounded">
                              <small className="text-muted d-block">
                                Custo Total
                              </small>
                              <strong className="text-danger fs-6">
                                {formatCurrency(
                                  filteredEmployees.reduce((sum, emp) => {
                                    return (
                                      sum +
                                       emp.salary +
                                      emp.decimoTerceiro +
                                      emp.ferias +
                                      emp.salariovariavel +   
                                      (emp.fgts * 12) +
                                      emp.feriasFgts +
                                      emp.decimoTerceiroFgts +
                                      (emp.pis * 12) +
                                      emp.feriasPis +
                                      emp.decimoTerceiroPis
                                    );
                                  }, 0)
                                )}
                              </strong>
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="text-center p-2 bg-white rounded">
                              <small className="text-muted d-block">
                                Custo Geral - Folha
                              </small>
                              <strong className="text-secondary fs-6">
                                {formatCurrency(TotalSalarioGlobal /*+ ((totalSalariosContratacoes * 1.133) * 12)*/  )}
                              </strong>
                            </div>
                          </div>
                        </div>

                        {/* Barra de progresso representando o percentual do total geral */}
                        <div className="mt-3">
                          <small className="text-muted">
                            Participação no Orçamento Total:
                          </small>
                          {(() => {
                            const totalSalariosCentro =
                              filteredEmployees.reduce(
                                (sum, emp) =>
                                  sum +
                                  emp.salary +
                                  (emp.fgts * 12) +
                                  emp.feriasFgts +
                                  emp.decimoTerceiroFgts +
                                  (emp.pis * 12) +
                                  emp.feriasPis +
                                  emp.decimoTerceiroPis +
                                  emp.salariovariavel, /*+ 
                                  ((totalSalariosContratacoes * 1.133) * 12)*/
                                0
                              );

                            const percentual =
                              TotalSalarioGlobal > 0
                                ? Math.round(
                                    (totalSalariosCentro / TotalSalarioGlobal) *
                                      100
                                  )
                                : 0;

                            return (
                              <>
                                <div
                                  className="progress mt-1"
                                  style={{ height: "8px" }}
                                >
                                  <div
                                    className="progress-bar bg-primary"
                                    style={{ width: `${percentual}%` }}
                                  ></div>
                                </div>
                                <small className="text-muted">
                                  <h5> {percentual}% </h5>
                                </small>
                              </>
                            );
                          })()}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Tabela Principal */}
          <div className="col-md-9">
            {!showMonthlyEvolution ? (
              <div className="card border-0 shadow-sm">
                <div className="card-header">
                  <h6 className="card-title mb-0">
                    Previsão por Funcionário e Centro de Custo
                    {loadingEmployees && (
                      <span className="ms-2">
                        <div
                          className="spinner-border spinner-border-sm"
                          role="status"
                        ></div>
                        <small className="ms-1">Carregando...</small>
                      </span>
                    )}
                  </h6>
                </div>
                <div className="card-body p-0">
                  {loadingEmployees ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Carregando...</span>
                      </div>
                      <p className="mt-2 text-muted">
                        Carregando dados dos funcionários...
                      </p>
                    </div>
                  ) : !selectedCostCenter ? (
                    <div className="text-center py-5">
                      <div className="mb-3">
                        <i
                          className="bi bi-filter-circle"
                          style={{ fontSize: "3rem", color: "#6c757d" }}
                        ></i>
                      </div>
                      <h5 className="text-muted">
                        Selecione um Centro de Custo
                      </h5>
                      <p className="text-muted">
                        Para visualizar os funcionários, selecione um centro de
                        custo específico no filtro ao lado.
                      </p>
                    </div>
                  ) : filteredEmployees.length === 0 ? (
                    <div className="text-center py-4">
                      <p className="text-muted">
                        Nenhum funcionário encontrado para o centro de custo
                        selecionado.
                      </p>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-hover mb-0">
                        <thead className="bg-light">
                          <tr>
                            <th>Chapa</th>
                            <th>Nome</th>
                            <th>Função</th>
                            <th>Salário Anual</th>
                            <th>Centro de Custo</th>
                            <th>Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredEmployees.map((emp) => (
                            <tr key={emp.id}>
                              <td>{emp.id}</td>
                              <td>{emp.name}</td>
                              <td>{emp.position}</td>
                              <td>
                                {formatCurrency(
                                  emp.salary +
                                    emp.decimoTerceiro +
                                    emp.ferias +
                                    emp.salariovariavel
                                )}
                              </td>
                              <td>
                                <span className="badge bg-secondary">
                                  {emp.costCenter}
                                </span>
                              </td>
                              <td>
                                <button
                                  className="btn btn-sm btn-primary me-1 mb-1"
                                  onClick={() => {
                                    setSelectedEmployee(emp);
                                    setShowSalaryModal(true);
                                  }}
                                >
                                  💰 Salário
                                </button>
                                <button
                                  className="btn btn-sm btn-info me-1 mb-1"
                                  onClick={() => {
                                    setSelectedEmployee(emp);
                                    setShowChargesModal(true);
                                  }}
                                >
                                  📊 Encargos
                                </button>
                                <button
                                  className="btn btn-sm btn-success mb-1"
                                  onClick={() => {
                                    setSelectedEmployee(emp);
                                    setShowMeritoModal(true);
                                  }}
                                >
                                  🏆 Mérito
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="card border-0 shadow-sm">
                <div className="card-header">
                  <h6 className="card-title mb-0">
                    📅 Evolução Mensal dos Salários
                  </h6>
                </div>
                <div className="card-body">
                  {!selectedCostCenter ? (
                    <div className="text-center py-4">
                      <p className="text-muted">
                        Selecione um centro de custo para visualizar a evolução
                        mensal.
                      </p>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-sm">
                        <thead className="bg-light">
                          <tr>
                            <th style={{ minWidth: "200px" }}>Funcionário</th>
                            {months.map((month) => (
                              <th
                                key={month}
                                className="text-center"
                                style={{ minWidth: "100px" }}
                              >
                                {month}
                              </th>
                            ))}

                           <th
                              className="text-center"
                              style={{ minWidth: "100px" }}
                            >
                              Variável
                            </th>

                            <th
                              className="text-center"
                              style={{ minWidth: "100px" }}
                            >
                              1/3 Férias
                            </th>


                            <th
                              className="text-center"
                              style={{ minWidth: "100px" }}
                            >
                              13º
                            </th>
                            <th
                              className="text-center"
                              style={{ minWidth: "120px" }}
                            >
                              Total Anual
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredEmployees.map((emp) => {
                            const thirteenth = emp.decimoTerceiro;
                            const ferias = emp.ferias;
                            const totalAnnual =
                              emp.monthlySalaries.reduce(
                                (sum, sal) => sum + sal,
                                0
                              ) +
                              thirteenth +
                              ferias;

                            return (
                              <tr key={emp.id}>
                                <td>
                                  <div>
                                    <strong>{emp.name}</strong>
                                    <small className="d-block text-muted">
                                      {emp.position}
                                    </small>
                                  </div>
                                </td>
                                {emp.monthlySalaries.map((salary, index) => (
                                  <td key={index}>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm"
                                      value={salary}
                                      onChange={(e) =>
                                        updateMonthlySalary(
                                          emp.id,
                                          index,
                                          e.target.value
                                        )
                                      }
                                      style={{ fontSize: "12px" }}
                                    />
                                  </td>
                                ))}
                                <td className="text-center">
                                  <span className="badge bg-success">
                                    {formatCurrency(ferias)}
                                  </span>
                                </td>

                                <td className="text-center">
                                  <span className="badge bg-success">
                                    {formatCurrency(thirteenth)}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="badge bg-primary">
                                    {formatCurrency(totalAnnual)}
                                  </span>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Aba Novas Contratações */}
      {activeTab === "novas" && (
        <div className="row">
          <div className="col-md-6">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-success text-white">
                <h6 className="card-title mb-0">
                  {editandoContratacao
                    ? "✏️ Editando Contratação"
                    : "➕ Cadastrar Nova Contratação"}
                </h6>
                {editandoContratacao && (
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => {
                      setEditandoContratacao(null);
                      setNovaContratacao({ area: "", vaga: "", salario: "" });
                    }}
                  >
                    ❌ Cancelar Edição
                  </button>
                )}
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <label className="form-label">Área</label>
                  <select
                    className="form-select"
                    value={
                      editandoContratacao
                        ? editandoContratacao.area
                        : novaContratacao.area
                    }
                    onChange={(e) => {
                      if (editandoContratacao) {
                        setEditandoContratacao({
                          ...editandoContratacao,
                          area: e.target.value,
                        });
                      } else {
                        setNovaContratacao({
                          ...novaContratacao,
                          area: e.target.value,
                        });
                      }
                    }}
                    disabled={loadingCostCenters}
                  >
                    <option value="">
                      {loadingCostCenters
                        ? "Carregando..."
                        : "Selecione a área"}
                    </option>
                    {costCentersData.map((center) => (
                      <option key={center.codigo} value={center.codigo}>
                        {center.nome}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Vaga</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Ex: Analista de Sistemas"
                        value={
                          editandoContratacao
                            ? editandoContratacao.vaga
                            : novaContratacao.vaga
                        }
                        onChange={(e) => {
                          if (editandoContratacao) {
                            setEditandoContratacao({
                              ...editandoContratacao,
                              vaga: e.target.value,
                            });
                          } else {
                            setNovaContratacao({
                              ...novaContratacao,
                              vaga: e.target.value,
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Salário</label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Ex: 4500.00"
                        value={
                          editandoContratacao
                            ? editandoContratacao.salario
                            : novaContratacao.salario
                        }
                        onChange={(e) => {
                          if (editandoContratacao) {
                            setEditandoContratacao({
                              ...editandoContratacao,
                              salario: e.target.value,
                            });
                          } else {
                            setNovaContratacao({
                              ...novaContratacao,
                              salario: e.target.value,
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Botões condicionais */}
                {editandoContratacao ? (
                  // Botões para edição
                  <div className="row">
                    <div className="col-md-6">
                      <div className="d-grid">
                        <button
                          className="btn btn-primary"
                          onClick={async () => {
                            const sucesso = await atualizarContratacao(
                              editandoContratacao.id,
                              editandoContratacao
                            );
                            if (sucesso) {
                              setEditandoContratacao(null);
                              setNovaContratacao({
                                area: "",
                                vaga: "",
                                salario: "",
                              });
                            }
                          }}
                          disabled={
                            !editandoContratacao.area ||
                            !editandoContratacao.vaga ||
                            !editandoContratacao.salario ||
                            loadingContratacoes
                          }
                        >
                          {loadingContratacoes ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2"></span>
                              Salvando...
                            </>
                          ) : (
                            "💾 Salvar Alterações"
                          )}
                        </button>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-grid">
                        <button
                          className="btn btn-danger"
                          onClick={async () => {
                            const sucesso = await deletarContratacao(
                              editandoContratacao.id
                            );
                            if (sucesso) {
                              setEditandoContratacao(null);
                              setNovaContratacao({
                                area: "",
                                vaga: "",
                                salario: "",
                              });
                            }
                          }}
                          disabled={loadingContratacoes}
                        >
                          {loadingContratacoes ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2"></span>
                              Excluindo...
                            </>
                          ) : (
                            "🗑️ Excluir"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  // Botão para cadastro
                  <div className="d-grid">
                    <button
                      className="btn btn-success"
                      onClick={cadastrarNovaContratacao}
                      disabled={
                        !novaContratacao.area ||
                        !novaContratacao.vaga ||
                        !novaContratacao.salario ||
                        loadingContratacoes
                      }
                    >
                      {loadingContratacoes ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Cadastrando...
                        </>
                      ) : (
                        "📝 Cadastrar"
                      )}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-info text-white">
                <h6 className="card-title mb-0">📋 Contratações Cadastradas</h6>
              </div>
              <div className="card-body">
                {contratacoesCadastradas.length === 0 ? (
                  <p className="text-muted text-center py-4">
                    {loadingContratacoes
                      ? "Carregando..."
                      : "Nenhuma contratação cadastrada ainda."}
                  </p>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-sm">
                      <thead className="bg-light">
                        <tr>
                          <th>Área</th>
                          <th>Vaga</th>
                          <th>Salário</th>
                          <th width="100">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {contratacoesCadastradas.map((contratacao) => (
                          <tr
                            key={contratacao.id}
                            className={
                              editandoContratacao?.id === contratacao.id
                                ? "table-warning"
                                : ""
                            }
                          >
                            <td>
                              <span className="badge bg-secondary">
                                {contratacao.nome}
                              </span>
                            </td>
                            <td>{contratacao.vaga}</td>
                            <td>{formatCurrency(contratacao.salario)}</td>
                            <td>
                              {/* BOTÃO DE DELETAR ADICIONADO */}
                              <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={async (e) => {
                                  e.stopPropagation();
                                  const sucesso = await deletarContratacao(
                                    contratacao.id
                                  );
                                  if (
                                    sucesso &&
                                    editandoContratacao?.id === contratacao.id
                                  ) {
                                    setEditandoContratacao(null);
                                    setNovaContratacao({
                                      area: "",
                                      vaga: "",
                                      salario: "",
                                    });
                                  }
                                }}
                                title="Excluir contratação"
                                disabled={loadingContratacoes}
                              >
                                🗑️
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-12 mt-4">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-primary text-white">
                <h6 className="card-title mb-0">
                  👥 Dashboard de Performance - Contratações por Área
                </h6>
              </div>
              <div className="card-body">
                {contratacoesCadastradas.length === 0 ? (
                  <div className="text-center py-5">
                    <div style={{ fontSize: "4rem" }}>👔</div>
                    <h5 className="text-muted mt-3">
                      Nenhuma contratação cadastrada
                    </h5>
                    <p className="text-muted">
                      Os dados de performance aparecerão aqui após o cadastro
                      das contratações.
                    </p>
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-12 mb-4">
                      <h6>🏆 Análise de Performance das Contratações</h6>
                    </div>
                    {(() => {
                      // Agrupar contratações por área
                      const contraracoesPorArea =
                        contratacoesCadastradas.reduce((acc, contratacao) => {
                          const area = contratacao.nome || "Área não definida";
                          if (!acc[area]) {
                            acc[area] = {
                              vagas: 0,
                              totalSalario: 0,
                              salarios: [],
                              cargos: [],
                            };
                          }
                          acc[area].vagas += 1;
                          acc[area].totalSalario += contratacao.salario;
                          acc[area].salarios.push(contratacao.salario);
                          acc[area].cargos.push(contratacao.vaga);
                          return acc;
                        }, {});

                      const totalInvestimento = contratacoesCadastradas.reduce(
                        (sum, c) => sum + c.salario,
                        0
                      );

                      return Object.entries(contraracoesPorArea).map(
                        ([area, dados]) => {
                          const salarioMax = Math.max(...dados.salarios);
                          const percentualDoCusto =
                            totalInvestimento > 0
                              ? ((dados.totalSalario) / totalInvestimento) * 100
                              : 0;
                          const impactoAnual = (dados.totalSalario) * 13.3; // Impacto anual

                          return (
                            <div key={area} className="col-md-6 col-lg-4 mb-4">
                              <div
                                className="card border-0 shadow-sm h-100"
                                style={{ borderLeft: "4px solid #28a745" }}
                              >
                                <div className="card-body">
                                  <div className="d-flex justify-content-between align-items-start mb-3">
                                    <div>
                                      <h6 className="card-title text-success fw-bold mb-1">
                                        {area}
                                      </h6>
                                      <span className="badge bg-success">
                                        {dados.vagas}{" "}
                                        {dados.vagas === 1 ? "vaga" : "vagas"}
                                      </span>
                                    </div>
                                    <div className="text-end">
                                      <div className="text-muted small">
                                        Salário Mensal
                                      </div>
                                      <div className="fw-bold text-info">
                                        {formatCurrency(salarioMax)}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="mb-3">
                                    <small className="text-muted">
                                      Custo Mensal Total
                                    </small>
                                    <div className="h5 fw-bold text-primary mb-1">
                                      {formatCurrency(impactoAnual / 12)}
                                    </div>
                                    <small className="text-muted">
                                      {percentualDoCusto.toFixed(1)}% do
                                      orçamento total
                                    </small>
                                  </div>

                                  <div className="mb-3">
                                    <small className="text-muted">
                                      Impacto Anual Estimado Salário
                                    </small>
                                    <div className="h6 fw-bold text-warning mb-1">
                                      {formatCurrency(impactoAnual)}
                                    </div>
                                  </div>

                                  <div className="mb-3">
                                    <small className="text-muted">
                                      Impacto Anual Estimado Encargos
                                    </small>
                                    <div className="h6 fw-bold text-warning mb-1">
                                      {formatCurrency(impactoAnual * 0.09) }
                                    </div>
                                  </div>

                                  <div className="mb-3">
                                    <div className="d-flex justify-content-between mb-1">
                                      <small className="text-muted">
                                        Participação no Orçamento
                                      </small>
                                      <small className="fw-bold">
                                        {percentualDoCusto.toFixed(1)}%
                                      </small>
                                    </div>
                                    <div
                                      className="progress"
                                      style={{ height: "8px" }}
                                    >
                                      <div
                                        className="progress-bar bg-gradient-success"
                                        style={{
                                          width: `${percentualDoCusto}%`,
                                          background:
                                            "linear-gradient(90deg, #1cc88a, #13855c)",
                                        }}
                                      ></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      );
                    })()}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Aba Treinamento */}
      {activeTab === "treinamento" && (
        <div className="row">
          {console.log(
            "🎓 Renderizando aba de treinamento - activeTab:",
            activeTab
          )}

          <div className="col-md-6">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-success text-white">
                <h6 className="card-title mb-0">
                  {editandoTreinamento
                    ? "✏️ Editando Treinamento"
                    : "➕ Cadastrar Novo Treinamento"}
                </h6>
                {editandoTreinamento && (
                  <button
                    className="btn btn-sm btn-outline-light mt-2"
                    onClick={() => {
                      setEditandoTreinamento(null);
                      setNovoTreinamento({
                        centrocusto: "",
                        curso: "",
                        participante: "",
                        duracao: "",
                        valor: "",
                      });
                    }}
                  >
                    ❌ Cancelar Edição
                  </button>
                )}
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <label className="form-label fw-bold">Centro de Custo</label>
                  <select
                    className="form-select"
                    value={
                      editandoTreinamento
                        ? editandoTreinamento.centrocusto
                        : novoTreinamento.centrocusto
                    }
                    onChange={(e) => {
                      if (editandoTreinamento) {
                        setEditandoTreinamento({
                          ...editandoTreinamento,
                          centrocusto: e.target.value,
                        });
                      } else {
                        setNovoTreinamento({
                          ...novoTreinamento,
                          centrocusto: e.target.value,
                        });
                      }
                    }}
                  >
                    <option value="">Selecione o centro de custo</option>
                    {costCentersData.map((center) => (
                      <option key={center.codigo} value={center.codigo}>
                        {center.nome}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label fw-bold">
                    Nome do Curso/Treinamento
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ex: Curso de Excel Avançado"
                    value={
                      editandoTreinamento
                        ? editandoTreinamento.curso
                        : novoTreinamento.curso
                    }
                    onChange={(e) => {
                      if (editandoTreinamento) {
                        setEditandoTreinamento({
                          ...editandoTreinamento,
                          curso: e.target.value,
                        });
                      } else {
                        setNovoTreinamento({
                          ...novoTreinamento,
                          curso: e.target.value,
                        });
                      }
                    }}
                  />
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label fw-bold">
                        Participantes
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Ex: 5"
                        value={
                          editandoTreinamento
                            ? editandoTreinamento.participante
                            : novoTreinamento.participante
                        }
                        onChange={(e) => {
                          if (editandoTreinamento) {
                            setEditandoTreinamento({
                              ...editandoTreinamento,
                              participante: e.target.value,
                            });
                          } else {
                            setNovoTreinamento({
                              ...novoTreinamento,
                              participante: e.target.value,
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label fw-bold">
                        Duração (horas)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Ex: 40"
                        value={
                          editandoTreinamento
                            ? editandoTreinamento.duracao
                            : novoTreinamento.duracao
                        }
                        onChange={(e) => {
                          if (editandoTreinamento) {
                            setEditandoTreinamento({
                              ...editandoTreinamento,
                              duracao: e.target.value,
                            });
                          } else {
                            setNovoTreinamento({
                              ...novoTreinamento,
                              duracao: e.target.value,
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label fw-bold">
                        Valor Total (R$)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Ex: 1200.00"
                        step="0.01"
                        value={
                          editandoTreinamento
                            ? editandoTreinamento.valor
                            : novoTreinamento.valor
                        }
                        onChange={(e) => {
                          if (editandoTreinamento) {
                            setEditandoTreinamento({
                              ...editandoTreinamento,
                              valor: e.target.value,
                            });
                          } else {
                            setNovoTreinamento({
                              ...novoTreinamento,
                              valor: e.target.value,
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Botões condicionais */}
                {editandoTreinamento ? (
                  // Botões para edição
                  <div className="row">
                    <div className="col-md-6">
                      <div className="d-grid">
                        <button
                          className="btn btn-primary"
                          onClick={async () => {
                            const sucesso = await atualizarTreinamento(
                              editandoTreinamento.id,
                              editandoTreinamento
                            );
                            if (sucesso) {
                              setEditandoTreinamento(null);
                              setNovoTreinamento({
                                centrocusto: "",
                                curso: "",
                                participante: "",
                                duracao: "",
                                valor: "",
                              });
                            }
                          }}
                          disabled={
                            !editandoTreinamento.centrocusto ||
                            !editandoTreinamento.curso ||
                            !editandoTreinamento.participante ||
                            !editandoTreinamento.duracao ||
                            !editandoTreinamento.valor ||
                            loadingTreinamentos
                          }
                        >
                          {loadingTreinamentos ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2"></span>
                              Salvando...
                            </>
                          ) : (
                            "💾 Salvar Alterações"
                          )}
                        </button>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-grid">
                        <button
                          className="btn btn-danger"
                          onClick={async () => {
                            const sucesso = await deletarTreinamento(
                              editandoTreinamento.id
                            );
                            if (sucesso) {
                              setEditandoTreinamento(null);
                              setNovoTreinamento({
                                centrocusto: "",
                                curso: "",
                                participante: "",
                                duracao: "",
                                valor: "",
                              });
                            }
                          }}
                          disabled={loadingTreinamentos}
                        >
                          {loadingTreinamentos ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2"></span>
                              Excluindo...
                            </>
                          ) : (
                            "🗑️ Excluir"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  // Botão para cadastro
                  <div className="d-grid">
                    <button
                      className="btn btn-success"
                      onClick={cadastrarNovoTreinamento}
                      disabled={
                        !novoTreinamento.centrocusto ||
                        !novoTreinamento.curso ||
                        !novoTreinamento.participante ||
                        !novoTreinamento.duracao ||
                        !novoTreinamento.valor ||
                        loadingTreinamentos
                      }
                    >
                      {loadingTreinamentos ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Cadastrando...
                        </>
                      ) : (
                        "📝 Cadastrar Treinamento"
                      )}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-info text-white">
                <h6 className="card-title mb-0">📋 Treinamentos Cadastrados</h6>
              </div>
              <div className="card-body">
                {loadingTreinamentos ? (
                  <div className="text-center py-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Carregando...</span>
                    </div>
                    <p className="mt-2 text-muted">
                      Carregando treinamentos...
                    </p>
                  </div>
                ) : treinamentosCadastrados.length === 0 ? (
                  <div className="text-center py-4">
                    <div className="mb-3">
                      <div style={{ fontSize: "4rem" }}>📚</div>
                    </div>
                    <h5 className="text-muted">
                      Nenhum treinamento cadastrado
                    </h5>
                    <p className="text-muted">
                      Cadastre o primeiro treinamento usando o formulário ao
                      lado.
                    </p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-sm table-hover">
                      <thead className="bg-light">
                        <tr>
                          <th>Centro de Custo</th>
                          <th>Curso</th>
                          <th>Participantes</th>
                          <th>Duração</th>
                          <th>Valor Total</th>
                          <th width="80">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {treinamentosCadastrados.map((treinamento) => (
                          <tr
                            key={treinamento.id}
                            className={
                              editandoTreinamento?.id === treinamento.id
                                ? "table-warning"
                                : ""
                            }
                          >
                            <td>
                              <span className="badge bg-secondary">
                                {treinamento.centrocusto}
                              </span>
                            </td>
                            <td>
                              <strong>{treinamento.curso}</strong>
                            </td>
                            <td>
                              <span className="badge bg-info">
                                {treinamento.participante}
                              </span>
                            </td>
                            <td>
                              <span className="badge bg-warning">
                                {treinamento.duracao}h
                              </span>
                            </td>
                            <td>
                              <span className="badge bg-success">
                                {formatCurrency(treinamento.valor)}
                              </span>
                            </td>
                            <td>
                              <button
                                className={`btn btn-sm ${
                                  editandoTreinamento?.id === treinamento.id
                                    ? "btn-warning"
                                    : "btn-outline-primary"
                                }`}
                                onClick={() => {
                                  if (
                                    editandoTreinamento?.id === treinamento.id
                                  ) {
                                    // Se já está editando este item, cancela a edição
                                    setEditandoTreinamento(null);
                                    setNovoTreinamento({
                                      centrocusto: "",
                                      curso: "",
                                      participante: "",
                                      duracao: "",
                                      valor: "",
                                    });
                                  } else {
                                    // Carrega os dados para edição
                                    setEditandoTreinamento({
                                      id: treinamento.id,
                                      centrocusto: treinamento.codccusto,
                                      curso: treinamento.curso,
                                      participante: treinamento.participante,
                                      duracao: treinamento.duracao,
                                      valor: treinamento.valor,
                                      CODCOLIGADA:
                                        treinamento.originalData?.CODCOLIGADA,
                                      CODFILIAL:
                                        treinamento.originalData?.CODFILIAL,
                                    });
                                  }
                                }}
                                title={
                                  editandoTreinamento?.id === treinamento.id
                                    ? "Cancelar edição"
                                    : "Editar"
                                }
                              >
                                {editandoTreinamento?.id === treinamento.id
                                  ? "❌"
                                  : "✏️"}
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-12 mt-4">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-primary text-white">
                <h6 className="card-title mb-0">
                  🎓 Dashboard de Performance - Treinamentos por Centro de Custo
                </h6>
              </div>
              <div className="card-body">
                {treinamentosCadastrados.length === 0 ? (
                  <div className="text-center py-5">
                    <div style={{ fontSize: "4rem" }}>📚</div>
                    <h5 className="text-muted mt-3">
                      Nenhum treinamento cadastrado
                    </h5>
                    <p className="text-muted">
                      Os dados de performance aparecerão aqui após o cadastro
                      dos treinamentos.
                    </p>
                  </div>
                ) : (
                  <div className="row">
                    {(() => {
                      // Agrupar treinamentos por centro de custo
                      const treinamentosPorCentro =
                        treinamentosCadastrados.reduce((acc, treinamento) => {
                          const centro =
                            treinamento.centrocusto || "Centro não definido";
                          if (!acc[centro]) {
                            acc[centro] = {
                              cursos: 0,
                              totalParticipantes: 0,
                              duracaoTotal: 0,
                              valorTotal: 0,
                              valores: [],
                              participantes: [],
                            };
                          }
                          acc[centro].cursos += 1;
                          acc[centro].totalParticipantes +=
                            treinamento.participante;
                          acc[centro].duracaoTotal += treinamento.duracao;
                          acc[centro].valorTotal += treinamento.valor;
                          acc[centro].valores.push(treinamento.valor);
                          acc[centro].participantes.push(
                            treinamento.participante
                          );
                          return acc;
                        }, {});

                      const totalInvestimento = treinamentosCadastrados.reduce(
                        (sum, t) => sum + t.valor,
                        0
                      );

                      return Object.entries(treinamentosPorCentro).map(
                        ([centro, dados]) => {
                          const valorPorParticipante =
                            dados.totalParticipantes > 0
                              ? dados.valorTotal / dados.totalParticipantes
                              : 0;
                          const percentualDoCusto =
                            totalInvestimento > 0
                              ? (dados.valorTotal / totalInvestimento) * 100
                              : 0;

                          return (
                            <div
                              key={centro}
                              className="col-md-6 col-lg-4 mb-4"
                            >
                              <div
                                className="card border-0 shadow-sm h-100"
                                style={{ borderLeft: "4px solid #007bff" }}
                              >
                                <div className="card-body">
                                  <div className="d-flex justify-content-between align-items-start mb-3">
                                    <div>
                                      <h6 className="card-title text-primary fw-bold mb-1">
                                        {centro}
                                      </h6>
                                      <span className="badge bg-primary">
                                        {dados.cursos}{" "}
                                        {dados.cursos === 1
                                          ? "curso"
                                          : "cursos"}
                                      </span>
                                    </div>
                                    <div className="text-end">
                                      <div className="text-muted small">
                                        Duração Total
                                      </div>
                                      <div className="fw-bold text-info">
                                        {dados.duracaoTotal}h
                                      </div>
                                    </div>
                                  </div>

                                  <div className="mb-3">
                                    <small className="text-muted">
                                      Investimento Total
                                    </small>
                                    <div className="h5 fw-bold text-success mb-1">
                                      {formatCurrency(dados.valorTotal)}
                                    </div>
                                    <small className="text-muted">
                                      {percentualDoCusto.toFixed(1)}% do
                                      orçamento total
                                    </small>
                                  </div>

                                  <div className="row text-center mb-3">
                                    <div className="col-6">
                                      <small className="text-muted d-block">
                                        Total Pessoas
                                      </small>
                                      <strong className="text-primary">
                                        {dados.totalParticipantes}
                                      </strong>
                                    </div>
                                    <div className="col-6">
                                      <small className="text-muted d-block">
                                        Custo/Pessoa
                                      </small>
                                      <strong className="text-success">
                                        {formatCurrency(valorPorParticipante)}
                                      </strong>
                                    </div>
                                  </div>
                                  <div className="mb-2">
                                    <div className="d-flex justify-content-between mb-1">
                                      <small className="text-muted">
                                        Participação no Orçamento
                                      </small>
                                      <small className="fw-bold">
                                        {percentualDoCusto.toFixed(1)}%
                                      </small>
                                    </div>
                                    <div
                                      className="progress"
                                      style={{ height: "8px" }}
                                    >
                                      <div
                                        className="progress-bar bg-gradient-success"
                                        style={{
                                          width: `${percentualDoCusto}%`,
                                          background:
                                            "linear-gradient(90deg, #1cc88a, #13855c)",
                                        }}
                                      ></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      );
                    })()}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Aba Orcamento */}
      {activeTab === "Orcamento" && (
        <div className="row">
          {/* Filtros 
          <div className="col-md-2">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-dark text-white">
                <h6 className="card-title mb-0">🔍 Reports</h6>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => navigate("/lancamentos/rel-ReportsHumano")}
                  >
                    📝 Folha Analiticas
                  </button>
                </div>
              </div>
            </div>
          </div>*/}

          {/* Dashboard Principal */}
          <div className="col-md-12">
            {/* Cards de Resumo */}
            <div className="row mb-4">
              <div className="col-md-2">
                <div className="card border-0 shadow-sm bg-warning text-white">
                  <div className="card-body text-center">
                    <h6 className="card-title">Total Funcionários + Novos</h6>
                    <h5 className="fw-bold">
                      {getDashboardData().totalFuncionarios /*+ (totalFuncionariosNovos) */ }
                    </h5>
                  </div>
                </div>
              </div>

              <div className="col-md-2">
                <div className="card border-0 shadow-sm bg-success text-white">
                  <div className="card-body text-center">
                    <h6 className="card-title">Total Salários + Novos</h6>
                    <h5 className="fw-bold">
                      {formatCurrency(getDashboardData().totalSalarios  /*+ ((totalSalariosContratacoes * 1.133) * 12)*/ )}
                    </h5>
                  </div>
                </div>
              </div>

              <div className="col-md-2">
                <div className="card border-0 shadow-sm bg-secondary text-white">
                  <div className="card-body text-center">
                    <h6 className="card-title">Total Encargos + Novos</h6>
                    <h5 className="fw-bold">
                      {formatCurrency(getDashboardData().totalEncargos)}
                    </h5>
                  </div>
                </div>
              </div>

              <div className="col-md-2">
                <div className="card border-0 shadow-sm bg-secondary text-white">
                  <div className="card-body text-center">
                    <h6 className="card-title">Total Abono + Novos</h6>
                    <h5 className="fw-bold">
                      {formatCurrency(getDashboardData().totalAbono)}
                    </h5>
                  </div>
                </div>
              </div>

              <div className="col-md-2">
                <div className="card border-0 shadow-sm bg-secondary text-white">
                  <div className="card-body text-center">
                    <h6 className="card-title">Total Rescisão + Novos </h6>
                    <h5 className="fw-bold">
                      {formatCurrency(getDashboardData().totalIndenizacao)}
                    </h5>
                  </div>
                </div>
              </div>

              <div className="col-md-2">
                <div className="card border-0 shadow-sm bg-primary text-white">
                  <div className="card-body text-center">
                    <h6 className="card-title">Custo Total + Novos </h6>
                    <h5 className="fw-bold">
                      {formatCurrency(getDashboardData().custoTotalRealizado  /*+ ((totalSalariosContratacoes * 1.133) * 12)*/ )}
                    </h5>
                  </div>
                </div>
              </div>
            </div>

            {/* Top 5 Centros de Custo */}
            <div className="row mb-12">
              <div className="col-md-12">
                <div className="card border-0 shadow-sm">
                  <div className="card-header">
                    <h6 className="card-title mb-0">Top 5 Centros de Custo</h6>
                  </div>
                  <div className="card-body">
                    {Object.entries(getDashboardData().dadosPorCentro)
                      .sort(
                        ([, a], [, b]) =>
                          b.salarios + b.encargos - (a.salarios + a.encargos)
                      )
                      .slice(0, 5)
                      .map(([centro, dados], index) => (
                        <div key={centro} className="mb-3">
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <span className="fw-bold">{centro}</span>
                            <span className="text-muted">
                              {formatCurrency(dados.salarios + dados.encargos)}
                            </span>
                          </div>
                          <div className="progress" style={{ height: "20px" }}>
                            <div
                              className={`progress-bar ${
                                index === 0
                                  ? "bg-warning"
                                  : index === 1
                                  ? "bg-info"
                                  : index === 2
                                  ? "bg-success"
                                  : "bg-secondary"
                              }`}
                              style={{ width: `${dados.percentual}%` }}
                            >
                              {dados.percentual}%
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Tabela Resumida com Drill-Down */}
            <div className="row">
              <div className="col-12">
                <div className="card border-0 shadow-sm">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className="card-title mb-0">
                      Resumo por Centro de Custo (Com Funcionários) - Clique
                      para expandir
                    </h6>
                    <small className="text-muted">
                      {expandedCostCenter && (
                        <button
                          className="btn btn-sm btn-outline-secondary"
                          onClick={() => setExpandedCostCenter("")}
                        >
                          🔄 Fechar Detalhes
                        </button>
                      )}
                    </small>
                  </div>
                  <div className="card-body p-0">
                    <div
                      className="table-responsive"
                      style={{ maxHeight: "400px", overflowY: "auto" }}
                    >
                      <table className="table table-hover mb-0 table-sm">
                        <thead className="bg-light sticky-top">
                          <tr>
                            <th>Centro de Custo</th>
                            <th>Funcionários</th>
                            <th>Salários</th>
                            <th>Encargos</th>
                            <th>Total</th>
                            <th>%</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Object.entries(getDashboardData().dadosPorCentro)
                            .sort(
                              ([, a], [, b]) =>
                                b.salarios +
                                b.encargos -
                                (a.salarios + a.encargos)
                            )
                            .map(([centro, dados]) => (
                              <React.Fragment key={centro}>
                                <tr
                                  className={`${
                                    expandedCostCenter === centro
                                      ? "table-primary"
                                      : ""
                                  }`}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => toggleDrillDown(centro)}
                                >
                                  <td>
                                    <span
                                      className="badge bg-secondary"
                                      style={{ fontSize: "0.7em" }}
                                    >
                                      {expandedCostCenter === centro
                                        ? "📂"
                                        : "📁"}{" "}
                                      {centro.length > 20
                                        ? centro.substring(0, 20) + "..."
                                        : centro}
                                    </span>
                                  </td>
                                  <td>{dados.funcionarios}</td>
                                  <td>{formatCurrency(dados.salarios)}</td>
                                  <td>{formatCurrency(dados.encargos)}</td>
                                  <td>
                                    <span className="fw-bold text-primary">
                                      {formatCurrency(
                                        dados.salarios + dados.encargos
                                      )}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="badge bg-warning">
                                      {dados.percentual}%
                                    </span>
                                  </td>
                                </tr>
                                {/* Drill-down: Mostrar funcionários do centro expandido */}
                                {expandedCostCenter === centro && (
                                  <tr>
                                    <td colSpan="6" className="p-0">
                                      <div className="bg-light p-3 border-top">
                                        <h6 className="mb-3 text-primary">
                                          👥 Funcionários - {centro}
                                        </h6>
                                        <div className="table-responsive">
                                          <table className="table table-sm table-bordered mb-0">
                                            <thead className="bg-secondary text-white">
                                              <tr>
                                                <th>Chapa</th>
                                                <th>Nome</th>
                                                <th>Cargo</th>
                                                <th>Salário</th>
                                                <th>FGTS</th>
                                                <th>PIS</th>
                                                <th>Total Encargos</th>
                                                <th>Custo Total</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {getEmployeesByCostCenter(
                                                centro
                                              ).map((emp) => {
                                                const fgts =
                                                  emp.fgts * 12 +
                                                  emp.feriasFgts +
                                                  emp.decimoTerceiroFgts;

                                                const pis =
                                                  emp.pis * 12 +
                                                  emp.feriasPis +
                                                  emp.decimoTerceiroPis;

                                                const totalEncargos =
                                                  fgts + pis;

                                                const custoTotal =
                                                  emp.salary +
                                                  emp.ferias +
                                                  emp.decimoTerceiro +
                                                  emp.salariovariavel +
                                                  totalEncargos;

                                                return (
                                                  <tr key={emp.id}>
                                                    <td>
                                                      <small>{emp.id}</small>
                                                    </td>
                                                    <td>
                                                      <strong>
                                                        {emp.name}
                                                      </strong>
                                                    </td>
                                                    <td>
                                                      <small>
                                                        {emp.position}
                                                      </small>
                                                    </td>
                                                    <td>
                                                      {formatCurrency(
                                                        emp.salary +
                                                          emp.decimoTerceiro +
                                                          emp.ferias +
                                                          emp.salariovariavel
                                                      )}
                                                    </td>
                                                    <td>
                                                      <small>
                                                        {formatCurrency(
                                                          emp.fgts * 12 +
                                                            emp.feriasFgts +
                                                            emp.decimoTerceiroFgts
                                                        )}
                                                      </small>
                                                    </td>
                                                    <td>
                                                      <small>
                                                        {formatCurrency(
                                                          emp.pis * 12 +
                                                            emp.feriasPis +
                                                            emp.decimoTerceiroPis
                                                        )}
                                                      </small>
                                                    </td>
                                                    <td>
                                                      <span className="badge bg-info">
                                                        {formatCurrency(
                                                          totalEncargos
                                                        )}
                                                      </span>
                                                    </td>
                                                    <td>
                                                      <span className="badge bg-primary">
                                                        {formatCurrency(
                                                          custoTotal
                                                        )}
                                                      </span>
                                                    </td>
                                                  </tr>
                                                );
                                              })}
                                            </tbody>
                                            <tfoot className="bg-light">
                                              <tr>
                                                <th colSpan="3">
                                                  TOTAL {centro}
                                                </th>
                                                <th>
                                                  {formatCurrency(
                                                    dados.salarios
                                                  )}
                                                </th>
                                                <th
                                                  colSpan="3"
                                                  className="text-center"
                                                >
                                                  {formatCurrency(
                                                    dados.encargos
                                                  )}
                                                </th>
                                                <th className="text-primary">
                                                  {formatCurrency(
                                                    dados.salarios +
                                                      dados.encargos
                                                  )}
                                                </th>
                                              </tr>
                                            </tfoot>
                                          </table>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            ))}
                        </tbody>
                        <tfoot className="bg-light">
                          <tr>
                            <th>TOTAL GERAL</th>
                            <th>{getDashboardData().totalFuncionarios}</th>
                            <th>
                              {formatCurrency(getDashboardData().totalSalarios)}
                            </th>
                            <th>
                              {formatCurrency(getDashboardData().totalEncargos)}
                            </th>
                            <th className="text-primary">
                              {formatCurrency(
                                getDashboardData().totalSalarios +
                                  getDashboardData().totalEncargos
                              )}
                            </th>
                            <th>100%</th>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Aba Orçado vs Realizado */}
      {activeTab === "orcado-realizado" && (
        <div className="row">
          {/* Main Dashboard */}
          <div className="col-md-12">
            {/* Header */}
            <div className="row mb-4">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h2 className="fw-bold text-block mb-1">
                      🎯 Folha Analítica Global
                    </h2>
                  </div>
                </div>
              </div>
            </div>

            {/* Cards Comparativos */}
            <div className="row mb-4">
              {(() => {
                const orcadoData = getDashboardData();
                //const orcadoData = getOrcadoData();
                const realizadoData = getDashboardDataOrcadoRealizado();

                const percentualExecucao =
                  orcadoData.custoTotal > 0
                    ? Math.min(
                        (realizadoData.custoTotalRealizado /
                          orcadoData.custoTotalRealizado) *
                          100,
                        100
                      ).toFixed(0)
                    : 0;

                const variationEncargos =
                  orcadoData.totalEncargos > 0
                    ? Math.min(
                        (realizadoData.totalEncargos /
                          orcadoData.totalEncargos) *
                          100,
                        100
                      ).toFixed(0)
                    : 0;

                const variationSalarios =
                  orcadoData.totalEncargos > 0
                    ? Math.min(
                        (realizadoData.totalSalarios /
                          (orcadoData.totalSalarios +
                            orcadoData.totalAbono +
                            orcadoData.totalIndenizacao)) *
                          100,
                        100
                      ).toFixed(0)
                    : 0;

                return (
                  <>
                    <div className="col-md-3">
                      <div
                        className="card border-0 shadow-sm"
                        style={{
                          background:
                            "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
                        }}
                      >
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <div>
                              <h6 className="text-muted mb-1">
                                👥 Total Funcionários
                              </h6>
                              <div className="d-flex align-items-center gap-2">
                                <span className="h5 fw-bold mb-0">
                                  {orcadoData.totalFuncionarios /*+ (totalFuncionariosNovos)*/}
                                </span>
                                <small className="badge bg-warning">
                                  Orçado
                                </small>
                              </div>
                              <div className="d-flex align-items-center gap-2 mt-1">
                                <span className="h5 fw-bold mb-0">
                                  {realizadoData.totalFuncionarios}
                                </span>
                                <small className="badge bg-secondary">
                                  Realizado
                                </small>
                              </div>
                            </div>
                          </div>
                          <small className="text-muted">
                            📊 Ocupação do Quadro
                          </small>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div
                        className="card border-0 shadow-sm"
                        style={{
                          background:
                            "linear-gradient(135deg, #fff7db 0%, #ffd699 100%)",
                        }}
                      >
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <div>
                              <h6 className="text-muted mb-1">
                                💰 Total Salários + Abono + Rescisão + Novos
                              </h6>
                              <div className="d-flex align-items-center gap-2">
                                <span className="h6 fw-bold mb-0">
                                  {formatCurrency(
                                    orcadoData.totalSalarios +
                                      orcadoData.totalAbono +
                                      orcadoData.totalIndenizacao  
                                      /*+ (totalSalariosContratacoes * 1.133)*/
                                  )}
                                </span>
                                <small className="badge bg-info">Orçado</small>
                              </div>
                              <div className="d-flex align-items-center gap-2 mt-1">
                                <span className="h6 fw-bold mb-0">
                                  {formatCurrency(realizadoData.totalSalarios)}
                                </span>
                                <small className="badge bg-secondary">
                                  Realizado
                                </small>
                              </div>
                            </div>
                          </div>
                          <div className="progress" style={{ height: "12px" }}>
                            <div
                              className="progress-bar bg-secondary"
                              style={{
                                width: `${variationSalarios}%`,
                              }}
                            >
                              {variationSalarios}%
                            </div>
                          </div>
                          <small className="text-muted">
                            💵 Consumo do Orçamento
                          </small>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div
                        className="card border-0 shadow-sm"
                        style={{
                          background:
                            "linear-gradient(135deg, #fff5e1 0%, #ffb88c 100%)",
                        }}
                      >
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <div>
                              <h6 className="text-muted mb-1">
                                📊 Total Encargos
                              </h6>
                              <div className="d-flex align-items-center gap-2">
                                <span className="h6 fw-bold mb-0">
                                  {formatCurrency(orcadoData.totalEncargos)}
                                </span>
                                <small className="badge bg-success">
                                  Orçado
                                </small>
                              </div>
                              <div className="d-flex align-items-center gap-2 mt-1">
                                <span className="h6 fw-bold mb-0">
                                  {formatCurrency(realizadoData.totalEncargos)}
                                </span>
                                <small className="badge bg-secondary">
                                  Realizado
                                </small>
                              </div>
                            </div>
                          </div>
                          <div className="progress" style={{ height: "12px" }}>
                            <div
                              className="progress-bar bg-secondary"
                              style={{
                                width: `${variationEncargos}%`,
                              }}
                            >
                              {variationEncargos}%
                            </div>
                          </div>
                          <small className="text-muted">
                            💸 Execução de Encargos
                          </small>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div
                        className="card border-0 shadow-sm"
                        style={{
                          background:
                            "linear-gradient(135deg, #faf3e0 0%, #f6d365 100%)",
                        }}
                      >
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <div>
                              <h6 className="text-muted mb-1">
                                🧮 Custo Total
                              </h6>
                              <div className="d-flex align-items-center gap-2">
                                <span className="h6 fw-bold mb-0">
                                  {formatCurrency(
                                    orcadoData.custoTotalRealizado  /*+ (totalSalariosContratacoes * 1.133)*/
                                  )}
                                </span>
                                <small className="badge bg-primary">
                                  Orçado
                                </small>
                              </div>
                              <div className="d-flex align-items-center gap-2 mt-1">
                                <span className="h6 fw-bold mb-0">
                                  {formatCurrency(
                                    realizadoData.custoTotalRealizado
                                  )}
                                </span>
                                <small className="badge bg-secondary">
                                  Realizado
                                </small>
                              </div>
                            </div>
                          </div>
                          <div className="progress" style={{ height: "12px" }}>
                            <div
                              className="progress-bar bg-secondary"
                              style={{
                                width: `${percentualExecucao}%`,
                              }}
                            >
                              {percentualExecucao}%
                            </div>
                          </div>
                          <small className="text-muted">
                            💎 Performance Total
                          </small>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })()}
            </div>

            {/* Cards de Projeção */}
            <div className="row mb-4">
              <div className="col-12">
                <div
                  className="card border-0 shadow-sm"
                  style={{
                    background:
                      "linear-gradient(135deg, #fff5e1 0%, #ffb88c 100%)",
                  }}
                >
                  <div className="card-header bg-transparent">
                    <h6 className="card-title mb-0">
                      🔮 Projeção para Dezembro/{selectedPeriod} (Baseada no
                      Realizado){" "}
                      <b>
                        {" "}
                        Cáculo ( (Realizado / {new Date().getMonth()}) * 12)
                      </b>
                    </h6>
                  </div>
                  <div className="card-body">
                    {(() => {
                      const projection = getProjectionData();
                      return (
                        <div className="row">
                          <div className="col-md-3">
                            <div className="text-center">
                              <small className="text-block">
                                👥 Funcionários Projetados
                              </small>
                              <h5 className="fw-bold text-block mb-1">
                                {projection.funcionariosProjetados}
                              </h5>
                              <small className="badge bg-warning"></small>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="text-center">
                              <small className="text-block">
                                💰 Salários Projetados
                              </small>
                              <h6 className="fw-bold text-block mb-1">
                                {formatCurrency(projection.salariosProjetados)}
                              </h6>
                             {/* <small
                                className={
                                  projection.SalarioProjetadoPerc >= 0
                                    ? "badge bg-danger"
                                    : "badge bg-success"
                                }
                              >
                                {projection.SalarioProjetadoPerc +
                                  " % do Orçado"}
                              </small> */}
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="text-center">
                              <small className="text-block">
                                📊 Encargos Projetados
                              </small>
                              <h6 className="fw-bold text-block mb-1">
                                {formatCurrency(projection.encargosProjetados)}
                              </h6>
                              {/* <small
                                className={
                                  projection.EncargosProjetadoPerc >= 0
                                    ? "badge bg-danger"
                                    : "badge bg-success"
                                }
                              >
                                {projection.EncargosProjetadoPerc +
                                  " % do Orçado"}
                              </small>*/}
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="text-center">
                              <small className="text-block">
                                🧮 Custo Total Projetado
                              </small>
                              <h6 className="fw-bold text-block mb-1">
                                {formatCurrency(projection.custoTotalProjetado)}
                              </h6>
                              {/*<small
                                className={
                                  projection.TotalProjetadoPerc >= 0
                                    ? "badge bg-danger"
                                    : "badge bg-success"
                                }
                              >
                                {projection.TotalProjetadoPerc + " % do Orçado"}
                              </small>*/}
                            </div>
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                </div>
              </div>
            </div>

            {/* Tabela Comparativa Detalhada */}
            <div className="row">
              <div className="col-12">
                <div className="card border-0 shadow-sm">
                  <div className="card-header bg-white">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="card-title mb-0">
                        📋 Análise Detalhada por Centro de Custo
                      </h6>
                      <div className="d-flex gap-2 flex-wrap">
                        <span className="badge bg-warning">📊 Orçado</span>
                        <span className="badge bg-secondary">💰 Realizado</span>
                        <span className="badge bg-info">🆕 Centro Novo</span>
                        <span className="badge bg-success">💰 Economizado</span>
                        <span className="badge bg-primary">📈 Variação</span>
                      </div>
                    </div>
                  </div>
                  <div className="card-body p-0">
                    <div
                      className="table-responsive"
                      style={{ maxHeight: "500px", overflowY: "auto" }}
                    >
                      <table className="table table-hover mb-0">
                        <thead
                          className="bg-light position-sticky"
                          style={{ top: 0, zIndex: 10 }}
                        >
                          <tr>
                            <th>Centro de Custo</th>
                            <th className="text-center">👥 Funcionários</th>
                            <th className="text-center">💰 Salários Orçado</th>
                            <th className="text-center">
                              💵 Salários Realizado
                            </th>
                            <th className="text-center">📊 Total Orçado</th>
                            <th className="text-center">🧮 Total Realizado</th>
                            <th className="text-center">📈 Saldo</th>
                            <th className="text-center">🎯 [%]</th>
                            <th className="text-center">⚡ Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(() => {
                            const orcadoData = getDashboardData(); //getOrcadoData();
                            const realizadoData =
                              getDashboardDataOrcadoRealizado();

                            // Debug para verificar os dados
                            console.log("Dados Orçados:", orcadoData);
                            console.log("Dados Realizados:", realizadoData);

                            // CORREÇÃO: Obter todos os centros únicos (orçados OU realizados)
                            const centrosOrcados = Object.keys(
                              orcadoData.dadosPorCentro
                            );
                            const centrosRealizados = Object.keys(
                              realizadoData.dadosPorCentro
                            );
                            const todosCentros = new Set([
                              ...centrosOrcados,
                              ...centrosRealizados,
                            ]);

                            return Array.from(todosCentros)
                              .sort() // Ordenar alfabeticamente
                              .map((centro) => {
                                const dadosOrcados =
                                  orcadoData.dadosPorCentro[centro];
                                const dadosRealizados =
                                  realizadoData.dadosPorCentro[centro];

                                // Classificar tipo de centro
                                const isSoOrcado =
                                  dadosOrcados && !dadosRealizados;
                                const isSoRealizado =
                                  !dadosOrcados && dadosRealizados; // CENTRO NOVO

                                // Pular centros completamente vazios
                                if (!dadosOrcados && !dadosRealizados)
                                  return null;

                                // CORREÇÃO: Definir valores seguros sem multiplicadores arbitrários
                                const valoresOrcados = dadosOrcados || {
                                  funcionarios: 0,
                                  salarios: 0,
                                  encargos: 0,
                                };
                                const valoresRealizados = dadosRealizados || {
                                  funcionarios: 0,
                                  salarios: 0,
                                  encargos: 0,
                                };

                                const totalOrcado =
                                  valoresOrcados.salarios +
                                  valoresOrcados.encargos;
                                const totalRealizado =
                                  valoresRealizados.salarios +
                                  valoresRealizados.encargos;

                                // Pular se ambos são zero
                                if (totalOrcado === 0 && totalRealizado === 0)
                                  return null;

                                // CORREÇÃO: Cálculo de aderência com proteção contra divisão por zero
                                let aderencia = 0;
                                let aderenciaTexto = "0%";

                                if (isSoRealizado) {
                                  aderenciaTexto = "NOVO";
                                } else if (isSoOrcado) {
                                  aderenciaTexto = "0%";
                                } else if (totalOrcado > 0) {
                                  aderencia = Math.round(
                                    (totalRealizado / totalOrcado) * 100
                                  );
                                  aderenciaTexto = `${aderencia}%`;
                                }

                                const variacao = totalRealizado - totalOrcado;

                                // Debug específico por centro
                                console.log(`Centro ${centro}:`, {
                                  tipo: isSoRealizado
                                    ? "NOVO"
                                    : isSoOrcado
                                    ? "SÓ ORÇADO"
                                    : "COMPLETO",
                                  funcionariosOrcados:
                                    valoresOrcados.funcionarios,
                                  funcionariosRealizados:
                                    valoresRealizados.funcionarios,
                                  totalOrcado,
                                  totalRealizado,
                                  aderencia: aderenciaTexto,
                                });

                                return (
                                  <React.Fragment key={centro}>
                                    <tr
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        toggleDrillDownComparative(centro)
                                      }
                                      className={
                                        expandedCostCenterComparative === centro
                                          ? "table-primary"
                                          : isSoRealizado
                                          ? "table-info" // Azul para centros novos
                                          : isSoOrcado
                                          ? "table-warning" // Amarelo para só orçado
                                          : "" // Normal para completos
                                      }
                                    >
                                      <td>
                                        <span
                                          className={`badge ${
                                            isSoRealizado
                                              ? "bg-info"
                                              : isSoOrcado
                                              ? "bg-warning"
                                              : "bg-secondary"
                                          }`}
                                          style={{ fontSize: "0.7em" }}
                                        >
                                          {expandedCostCenterComparative ===
                                          centro
                                            ? "📂"
                                            : "📁"}{" "}
                                          {isSoRealizado
                                            ? "🆕"
                                            : isSoOrcado
                                            ? "📋"
                                            : "📊"}{" "}
                                          {centro.length > 20
                                            ? centro.substring(0, 20) + "..."
                                            : centro}
                                        </span>
                                        {isSoRealizado && (
                                          <small className="text-info d-block">
                                            Centro Novo
                                          </small>
                                        )}
                                        {isSoOrcado && (
                                          <small className="text-warning d-block">
                                            Não Executado
                                          </small>
                                        )}
                                      </td>

                                      <td className="text-center">
                                        <span className="badge bg-warning">
                                          {valoresOrcados.funcionarios}
                                        </span>{" "}
                                        /
                                        <span className="badge bg-secondary">
                                          {valoresRealizados.funcionarios}
                                        </span>
                                      </td>

                                      <td className="text-center">
                                        {formatCurrency(
                                          valoresOrcados.salarios
                                        )}
                                      </td>

                                      <td className="text-center">
                                        {formatCurrency(
                                          valoresRealizados.salarios
                                        )}
                                      </td>

                                      <td className="text-center">
                                        {formatCurrency(totalOrcado)}
                                      </td>

                                      <td className="text-center">
                                        {formatCurrency(totalRealizado)}
                                      </td>

                                      <td className="text-center">
                                        {isSoRealizado ? (
                                          // Centro novo: mostrar como gasto não previsto
                                          <>
                                            <div
                                              className="progress"
                                              style={{
                                                height: "8px",
                                                marginBottom: "4px",
                                              }}
                                            >
                                              <div
                                                className="progress-bar bg-danger"
                                                style={{ width: "100%" }}
                                              ></div>
                                            </div>
                                            <small className="text-danger">
                                              +{formatCurrency(totalRealizado)}{" "}
                                              (não orçado)
                                            </small>
                                          </>
                                        ) : isSoOrcado ? (
                                          // Só orçado: mostrar economia
                                          <>
                                            <div
                                              className="progress"
                                              style={{
                                                height: "8px",
                                                marginBottom: "4px",
                                              }}
                                            >
                                              <div
                                                className="progress-bar bg-success"
                                                style={{ width: "0%" }}
                                              ></div>
                                            </div>
                                            <small className="text-success">
                                              -{formatCurrency(totalOrcado)}{" "}
                                              (economizado)
                                            </small>
                                          </>
                                        ) : (
                                          // Comparação normal
                                          <>
                                            <div
                                              className="progress"
                                              style={{
                                                height: "8px",
                                                marginBottom: "4px",
                                              }}
                                            >
                                              <div
                                                className={`progress-bar ${
                                                  aderencia <= 100
                                                    ? "bg-success"
                                                    : "bg-warning"
                                                }`}
                                                style={{
                                                  width: `${Math.min(
                                                    aderencia,
                                                    100
                                                  )}%`,
                                                }}
                                              ></div>
                                            </div>
                                            <small
                                              className={
                                                variacao >= 0
                                                  ? "text-danger"
                                                  : "text-success"
                                              }
                                            >
                                              {variacao >= 0 ? "" : ""}
                                              {formatCurrency(variacao)}
                                            </small>
                                          </>
                                        )}
                                      </td>

                                      <td className="text-center">
                                        {isSoRealizado ? (
                                          <span className="badge bg-danger">
                                            NOVO
                                          </span>
                                        ) : isSoOrcado ? (
                                          <span className="badge bg-success">
                                            0%
                                          </span>
                                        ) : (
                                          <span
                                            className={`badge ${
                                              aderencia <= 100
                                                ? "bg-success"
                                                : "bg-warning"
                                            }`}
                                          >
                                            {aderenciaTexto}
                                          </span>
                                        )}
                                      </td>

                                      <td className="text-center">
                                        {isSoRealizado
                                          ? "🆕"
                                          : isSoOrcado
                                          ? "💰"
                                          : aderencia <= 100
                                          ? "✅"
                                          : "⚠️"}
                                      </td>
                                    </tr>

                                    {/* Drill-down */}
                                    {expandedCostCenterComparative ===
                                      centro && (
                                      <tr>
                                        <td colSpan="9" className="p-0">
                                          <div className="bg-light p-3 border-top">
                                            <h6 className="mb-3 text-primary">
                                              👥 Funcionários - {centro}
                                              {isSoRealizado && (
                                                <span className="badge bg-info ms-2">
                                                  CENTRO NOVO
                                                </span>
                                              )}
                                              {isSoOrcado && (
                                                <span className="badge bg-warning ms-2">
                                                  NÃO EXECUTADO
                                                </span>
                                              )}
                                            </h6>
                                            <div className="table-responsive">
                                              <table className="table table-sm table-bordered mb-0">
                                                <thead className="bg-secondary text-white">
                                                  <tr>
                                                    <th>Chapa</th>
                                                    <th>Nome</th>
                                                    <th>Cargo</th>
                                                    <th>💰 Salário Orçado</th>
                                                    <th>
                                                      💵 Salário Realizado
                                                    </th>
                                                    <th>📊 Encargos Orçado</th>
                                                    <th>
                                                      💸 Encargos Realizado
                                                    </th>
                                                    <th>🧮 Total Orçado</th>
                                                    <th>💎 Total Realizado</th>
                                                    <th>📈 Variação</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {getEmployeesByCostCenterOrcRealizado(
                                                    centro
                                                  ).map((emp) => {
                                                    // CORREÇÃO: Cálculo correto da variação por funcionário
                                                    const variacaoEmp =
                                                      emp.totalRealizado -
                                                      emp.totalOrcado;

                                                    return (
                                                      <tr key={emp.id}>
                                                        <td>
                                                          <small>
                                                            {emp.id}
                                                          </small>
                                                        </td>
                                                        <td>
                                                          <strong>
                                                            {emp.name}
                                                          </strong>
                                                        </td>
                                                        <td>
                                                          <small>
                                                            {emp.position}
                                                          </small>
                                                        </td>
                                                        <td>
                                                          {formatCurrency(
                                                            emp.salaryOrcado
                                                          )}
                                                        </td>
                                                        <td>
                                                          {formatCurrency(
                                                            emp.salaryRealizado
                                                          )}
                                                        </td>
                                                        <td>
                                                          {formatCurrency(
                                                            emp.encargoOrcado
                                                          )}
                                                        </td>
                                                        <td>
                                                          {formatCurrency(
                                                            emp.encargoRealizado
                                                          )}
                                                        </td>
                                                        <td>
                                                          <span className="badge bg-primary">
                                                            {formatCurrency(
                                                              emp.totalOrcado
                                                            )}
                                                          </span>
                                                        </td>
                                                        <td>
                                                          <span className="badge bg-secondary">
                                                            {formatCurrency(
                                                              emp.totalRealizado
                                                            )}
                                                          </span>
                                                        </td>
                                                        <td>
                                                          <span
                                                            className={
                                                              variacaoEmp >= 0
                                                                ? "text-danger"
                                                                : "text-success"
                                                            }
                                                          >
                                                            {variacaoEmp >= 0
                                                              ? "+"
                                                              : ""}
                                                            {formatCurrency(
                                                              variacaoEmp
                                                            )}
                                                          </span>
                                                        </td>
                                                      </tr>
                                                    );
                                                  })}
                                                </tbody>
                                                <tfoot className="bg-light">
                                                  <tr>
                                                    <th colSpan="3">
                                                      TOTAL {centro}
                                                    </th>
                                                    <th>
                                                      {formatCurrency(
                                                        valoresOrcados.salarios
                                                      )}
                                                    </th>
                                                    <th>
                                                      {formatCurrency(
                                                        valoresRealizados.salarios
                                                      )}
                                                    </th>
                                                    <th>
                                                      {formatCurrency(
                                                        valoresOrcados.encargos
                                                      )}
                                                    </th>
                                                    <th>
                                                      {formatCurrency(
                                                        valoresRealizados.encargos
                                                      )}
                                                    </th>
                                                    <th className="text-primary">
                                                      {formatCurrency(
                                                        totalOrcado
                                                      )}
                                                    </th>
                                                    <th className="text-secondary">
                                                      {formatCurrency(
                                                        totalRealizado
                                                      )}
                                                    </th>
                                                    <th
                                                      className={
                                                        variacao >= 0
                                                          ? "text-danger"
                                                          : "text-success"
                                                      }
                                                    >
                                                      {variacao >= 0 ? "+" : ""}
                                                      {formatCurrency(variacao)}
                                                    </th>
                                                  </tr>
                                                </tfoot>
                                              </table>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  </React.Fragment>
                                );
                              })
                              .filter(Boolean); // Remove nulls
                          })()}
                        </tbody>
                        <tfoot className="bg-light">
                          {(() => {
                            const orcadoData = getDashboardData();
                            const realizadoData =
                              getDashboardDataOrcadoRealizado();

                            // Calcular totais gerais
                            const totalOrcadoGeral =
                              orcadoData.custoTotalRealizado;
                            const totalRealizadoGeral =
                              realizadoData.custoTotalRealizado;
                            const totalVariacao =
                              totalRealizadoGeral - totalOrcadoGeral;
                            const aderenciaGeral =
                              totalOrcadoGeral > 0
                                ? Math.round(
                                    (totalRealizadoGeral / totalOrcadoGeral) *
                                      100
                                  )
                                : 0;

                            // Identificar centros novos
                            const centrosNovos = Object.keys(
                              realizadoData.dadosPorCentro
                            ).filter(
                              (centro) => !orcadoData.dadosPorCentro[centro]
                            );

                            const gastoEmCentrosNovos = centrosNovos.reduce(
                              (total, centro) => {
                                const dados =
                                  realizadoData.dadosPorCentro[centro];
                                return total + dados.salarios + dados.encargos;
                              },
                              0
                            );

                            // Identificar centros não executados (só orçados)
                            const centrosNaoExecutados = Object.keys(
                              orcadoData.dadosPorCentro
                            ).filter(
                              (centro) => !realizadoData.dadosPorCentro[centro]
                            );

                            const valorEconomizado =
                              centrosNaoExecutados.reduce((total, centro) => {
                                const dados = orcadoData.dadosPorCentro[centro];
                                return total + dados.salarios + dados.encargos;
                              }, 0);

                            return (
                              <>
                                {/* Linha de centros novos */}
                                {centrosNovos.length > 0 && (
                                  <tr className="table-info">
                                    <td>
                                      🆕{" "}
                                      <strong>
                                        CENTROS NOVOS ({centrosNovos.length})
                                      </strong>
                                    </td>
                                    <td className="text-center">
                                      <span className="badge bg-warning">
                                        0
                                      </span>{" "}
                                      /
                                      <span className="badge bg-secondary">
                                        {centrosNovos.reduce(
                                          (total, centro) =>
                                            total +
                                            realizadoData.dadosPorCentro[centro]
                                              .funcionarios,
                                          0
                                        )}
                                      </span>
                                    </td>
                                    <td className="text-center">
                                      {formatCurrency(0)}
                                    </td>
                                    <td className="text-center">
                                      {formatCurrency(
                                        centrosNovos.reduce(
                                          (total, centro) =>
                                            total +
                                            realizadoData.dadosPorCentro[centro]
                                              .salarios,
                                          0
                                        )
                                      )}
                                    </td>
                                    <td className="text-center">
                                      {formatCurrency(0)}
                                    </td>
                                    <td className="text-center">
                                      {formatCurrency(gastoEmCentrosNovos)}
                                    </td>
                                    <td className="text-center">
                                      <small className="text-danger">
                                        +{formatCurrency(gastoEmCentrosNovos)}{" "}
                                        (não orçado)
                                      </small>
                                    </td>
                                    <td className="text-center">
                                      <span className="badge bg-danger">
                                        NOVO
                                      </span>
                                    </td>
                                    <td className="text-center">🆕</td>
                                  </tr>
                                )}

                                {/* Linha de centros não executados */}
                                {centrosNaoExecutados.length > 0 && (
                                  <tr className="table-warning">
                                    <td>
                                      💰{" "}
                                      <strong>
                                        NÃO EXECUTADOS (
                                        {centrosNaoExecutados.length})
                                      </strong>
                                    </td>
                                    <td className="text-center">
                                      <span className="badge bg-warning">
                                        {centrosNaoExecutados.reduce(
                                          (total, centro) =>
                                            total +
                                            orcadoData.dadosPorCentro[centro]
                                              .funcionarios,
                                          0
                                        )}
                                      </span>{" "}
                                      /
                                      <span className="badge bg-secondary">
                                        0
                                      </span>
                                    </td>
                                    <td className="text-center">
                                      {formatCurrency(
                                        centrosNaoExecutados.reduce(
                                          (total, centro) =>
                                            total +
                                            orcadoData.dadosPorCentro[centro]
                                              .salarios,
                                          0
                                        )
                                      )}
                                    </td>
                                    <td className="text-center">
                                      {formatCurrency(0)}
                                    </td>
                                    <td className="text-center">
                                      {formatCurrency(valorEconomizado)}
                                    </td>
                                    <td className="text-center">
                                      {formatCurrency(0)}
                                    </td>
                                    <td className="text-center">
                                      <small className="text-success">
                                        -{formatCurrency(valorEconomizado)}{" "}
                                        (economizado)
                                      </small>
                                    </td>
                                    <td className="text-center">
                                      <span className="badge bg-success">
                                        0%
                                      </span>
                                    </td>
                                    <td className="text-center">💰</td>
                                  </tr>
                                )}

                                {/* Total geral */}
                                <tr className="fw-bold">
                                  <td>🏆 TOTAL GERAL</td>
                                  <td className="text-center">
                                    <span className="badge bg-warning">
                                      {orcadoData.totalFuncionarios}
                                    </span>{" "}
                                    /
                                    <span className="badge bg-secondary">
                                      {realizadoData.totalFuncionarios}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    {formatCurrency(orcadoData.totalSalarios)}
                                  </td>
                                  <td className="text-center">
                                    {formatCurrency(
                                      realizadoData.totalSalarios
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {formatCurrency(totalOrcadoGeral)}
                                  </td>
                                  <td className="text-center">
                                    {formatCurrency(totalRealizadoGeral)}
                                  </td>
                                  <td className="text-center">
                                    <div
                                      className="progress"
                                      style={{
                                        height: "8px",
                                        marginBottom: "4px",
                                      }}
                                    >
                                      <div
                                        className="progress-bar bg-primary"
                                        style={{
                                          width: `${Math.min(
                                            aderenciaGeral,
                                            100
                                          )}%`,
                                        }}
                                      ></div>
                                    </div>
                                    <small
                                      className={
                                        totalVariacao >= 0
                                          ? "text-danger"
                                          : "text-success"
                                      }
                                    >
                                      {totalVariacao >= 0 ? "+" : ""}
                                      {formatCurrency(totalVariacao)}
                                    </small>
                                  </td>
                                  <td className="text-center">
                                    <span className="badge bg-primary">
                                      {aderenciaGeral}%
                                    </span>
                                  </td>
                                  <td className="text-center">🎯</td>
                                </tr>
                              </>
                            );
                          })()}
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Aba Cenário Geral */}
      {activeTab === "cenario" && (
        <div className="row">
          <div className="col-md-12">
            {/* Header */}
            <div className="row mb-4">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h2 className="fw-bold text-black mb-1">
                      🎁 Cenário Geral com Benefícios - {getCenarioData().ano}
                    </h2>
                  </div>
                </div>
              </div>
            </div>

            {/* Loading State */}
            {loadingCenario && (
              <div className="row mb-4">
                <div className="col-12">
                  <div className="card border-0 shadow-sm">
                    <div className="card-body text-center py-5">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Carregando...</span>
                      </div>
                      <p className="mt-3 text-muted">
                        Carregando dados do cenário da API...
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Mostrar dados apenas quando não estiver carregando */}
            {!loadingCenario && (
              <>
                {/* Cards de Resumo do Cenário */}
                <div className="row mb-4">
                  <div className="col-md-12">
                    <div className="card border-0 shadow-sm">
                      <div
                        className="card-header bg-gradient"
                        style={{
                          background:
                            "linear-gradient(135deg, #fff5e1 0%, #ffb88c 100%)",
                          color: "black",
                        }}
                      >
                        <h6 className="card-title mb-0">
                          🏢 Resumo Executivo - Cenário {getCenarioData().ano}
                        </h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          {/*<div className="col-md-2">
                            <div className="card border-0 shadow-sm">
                              <div
                                className="card-body text-center p-3"
                                style={{
                                  background:
                                    "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
                                }}
                              >
                                <h6 className="card-title text-black mb-2">
                                  👥 TOTAL FUNCIONÁRIOS
                                </h6>
                                <h3 className="fw-bold text-black mb-0">
                                  {getCenarioData().totalFuncionarios}
                                </h3>
                                <small className="text-black">
                                  colaboradores
                                </small>
                              </div>
                            </div>
                          </div> */}

                          <div className="col-md-2">
                            <div className="card border-0 shadow-sm">
                              <div
                                className="card-body text-center p-3"
                                style={{
                                  background:
                                    "linear-gradient(135deg, #fff5e1 0%, #ffb88c 100%)",
                                }}
                              >
                                <h6 className="card-title text-black mb-2">
                                  💰 SALÁRIOS + NOVOS
                                </h6>
                                <h5 className="fw-bold text-black mb-0">
                                  {formatCurrency(
                                    getCenarioData().totalSalarios  /*+ (totalSalariosContratacoes * 1.133)*/
                                  )}
                                </h5>
                                <small className="text-black">anual</small>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="card border-0 shadow-sm">
                              <div
                                className="card-body text-center p-3"
                                style={{
                                  background:
                                    "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
                                }}
                              >
                                <h6 className="card-title text-black mb-2">
                                  📊 ENCARGOS
                                </h6>
                                <h5 className="fw-bold text-black mb-0">
                                  {formatCurrency(
                                    getCenarioData().totalEncargos
                                  )}
                                </h5>
                                <small className="text-black">anual</small>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="card border-0 shadow-sm">
                              <div
                                className="card-body text-center p-3"
                                style={{
                                  background:
                                    "linear-gradient(135deg, #fff5e1 0%, #ffb88c 100%)",
                                }}
                              >
                                <h6 className="card-title text-black mb-2">
                                  💰 ABONO + RESCISÃO
                                </h6>
                                <h5 className="fw-bold text-black mb-0">
                                  {formatCurrency(
                                    getCenarioData().totalAbono +
                                      getCenarioData().totalIndenizacao
                                  )}
                                </h5>
                                <small className="text-black">anual</small>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="card border-0 shadow-sm">
                              <div
                                className="card-body text-center p-3"
                                style={{
                                  background:
                                    "linear-gradient(135deg, #fff5e1 0%, #ffb88c 100%)",
                                }}
                              >
                                <h6 className="card-title text-black mb-2">
                                  🎁 BENEFÍCIOS
                                </h6>
                                <h5 className="fw-bold text-black mb-0">
                                  {formatCurrency(
                                    getCenarioData().totalBeneficios
                                  )}
                                </h5>
                                <small className="text-black">anual</small>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="card border-0 shadow-sm">
                              <div
                                className="card-body text-center p-3"
                                style={{
                                  background:
                                    "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
                                }}
                              >
                                <h6 className="card-title text-black  mb-2">
                                  💸 REDUTOR
                                </h6>
                                <h5 className="fw-bold text-black mb-0">
                                  {formatCurrency(getCenarioData().redutor)}
                                </h5>
                                <small className="text-black">anual</small>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="card border-0 shadow-sm">
                              <div
                                className="card-body text-center text-black  p-3"
                                style={{
                                  background:
                                    "linear-gradient(135deg, #fff5e1 0%, #ffb88c 100%)",
                                  color: "white",
                                }}
                              >
                                <h6 className="card-title mb-2">🧮 TOTAL RH</h6>
                                <h4 className="fw-bold mb-0">
                                  {formatCurrency(getCenarioData().totalRH /*+ (totalSalariosContratacoes * 1.133)*/ )}
                                </h4>
                                <small>custo total anual</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Análise Detalhada */}
                <div className="row mb-4">
                  <div className="col-md-12">
                    <div className="card border-0 shadow-sm">
                      <div
                        className="card-header bg-gradient"
                        style={{
                          background:
                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          color: "white",
                        }}
                      >
                        <h6 className="card-title mb-0">
                          📈 Análise Detalhada dos Custos
                        </h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-6">
                            <h6 className="text-muted mb-3">
                              Distribuição Percentual
                            </h6>
                            {(() => {
                              const data = getCenarioData();
                              const totalSemReductor =
                                data.totalSalarios +
                                data.totalEncargos +
                                data.totalBeneficios;

                              // Evitar divisão por zero
                              if (totalSemReductor === 0) {
                                return (
                                  <div className="text-center text-muted py-4">
                                    <p>Nenhum dado disponível para análise</p>
                                  </div>
                                );
                              }

                              const percSalarios = (
                                (data.totalSalarios / totalSemReductor) *
                                100
                              ).toFixed(1);
                              const percEncargos = (
                                (data.totalEncargos / totalSemReductor) *
                                100
                              ).toFixed(1);
                              const percBeneficios = (
                                (data.totalBeneficios / totalSemReductor) *
                                100
                              ).toFixed(1);
                              const percReductor = (
                                (data.redutor / totalSemReductor) *
                                100
                              ).toFixed(1);

                              return (
                                <div>
                                  <div className="mb-3">
                                    <div className="d-flex justify-content-between mb-1">
                                      <span>💰 Salários</span>
                                      <span className="fw-bold">
                                        {percSalarios}%
                                      </span>
                                    </div>
                                    <div
                                      className="progress"
                                      style={{ height: "25px" }}
                                    >
                                      <div
                                        className="progress-bar bg-success"
                                        style={{ width: `${percSalarios}%` }}
                                      >
                                        {percSalarios}%
                                      </div>
                                    </div>
                                  </div>

                                  <div className="mb-3">
                                    <div className="d-flex justify-content-between mb-1">
                                      <span>📊 Encargos</span>
                                      <span className="fw-bold">
                                        {percEncargos}%
                                      </span>
                                    </div>
                                    <div
                                      className="progress"
                                      style={{ height: "25px" }}
                                    >
                                      <div
                                        className="progress-bar bg-info"
                                        style={{ width: `${percEncargos}%` }}
                                      >
                                        {percEncargos}%
                                      </div>
                                    </div>
                                  </div>

                                  <div className="mb-3">
                                    <div className="d-flex justify-content-between mb-1">
                                      <span>🎁 Benefícios</span>
                                      <span className="fw-bold">
                                        {percBeneficios}%
                                      </span>
                                    </div>
                                    <div
                                      className="progress"
                                      style={{ height: "25px" }}
                                    >
                                      <div
                                        className="progress-bar bg-warning"
                                        style={{ width: `${percBeneficios}%` }}
                                      >
                                        {percBeneficios}%
                                      </div>
                                    </div>
                                  </div>

                                  <div className="mb-3">
                                    <div className="d-flex justify-content-between mb-1">
                                      <span>💸 Redutor</span>
                                      <span className="fw-bold text-danger">
                                        -{percReductor}%
                                      </span>
                                    </div>
                                    <div
                                      className="progress"
                                      style={{ height: "25px" }}
                                    >
                                      <div
                                        className="progress-bar bg-danger"
                                        style={{ width: `${percReductor}%` }}
                                      >
                                        -{percReductor}%
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })()}
                          </div>

                          <div className="col-md-6">
                            <h6 className="text-muted mb-3">
                              Comparativo de Valores
                            </h6>
                            <div className="table-responsive">
                              <table className="table table-sm table-hover">
                                <thead className="table-light">
                                  <tr>
                                    <th>Componente</th>
                                    <th className="text-end">Valor Anual</th>
                                    <th className="text-end">Média Mensal</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>💰 Salários</td>
                                    <td className="text-end fw-bold text-success">
                                      {formatCurrency(
                                         (getCenarioData().totalSalarios /*+ (totalSalariosContratacoes * 1.133)*/ )
                                      )}
                                    </td>
                                    <td className="text-end text-success">
                                      {formatCurrency(
                                        (getCenarioData().totalSalarios) /*+ (totalSalariosContratacoes * 1.133)) / 12*/
                                      )}
                                    </td>
                                  </tr>
                                  
                                  <tr>
                                    <td>💰 Abono + Encargo</td>
                                    <td className="text-end fw-bold text-success">
                                      {formatCurrency(
                                         ( getCenarioData().totalAbono + getCenarioData().totalIndenizacao )
                                      )}
                                    </td>
                                    <td className="text-end text-success">
                                      {formatCurrency(
                                        ( getCenarioData().totalAbono + getCenarioData().totalIndenizacao ) / 12
                                      )}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td>📊 Encargos</td>
                                    <td className="text-end fw-bold text-info">
                                      {formatCurrency(
                                        getCenarioData().totalEncargos
                                      )}
                                    </td>
                                    <td className="text-end text-info">
                                      {formatCurrency(
                                        getCenarioData().totalEncargos / 12
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>🎁 Benefícios</td>
                                    <td className="text-end fw-bold text-warning">
                                      {formatCurrency(
                                        getCenarioData().totalBeneficios
                                      )}
                                    </td>
                                    <td className="text-end text-warning">
                                      {formatCurrency(
                                        getCenarioData().totalBeneficios / 12
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>💸 Redutor</td>
                                    <td className="text-end fw-bold text-danger">
                                      -
                                      {formatCurrency(getCenarioData().redutor)}
                                    </td>
                                    <td className="text-end text-danger">
                                      -
                                      {formatCurrency(
                                        getCenarioData().redutor / 12
                                      )}
                                    </td>
                                  </tr>
                                  <tr className="table-primary">
                                    <td>
                                      <strong>🧮 Total RH</strong>
                                    </td>
                                    <td className="text-end fw-bold text-primary">
                                      <strong>
                                        {formatCurrency(
                                          getCenarioData().totalRH /*+ ((totalSalariosContratacoes * 1.133))*/ 
                                        )}
                                      </strong>
                                    </td>
                                    <td className="text-end text-primary">
                                      <strong>
                                        {formatCurrency(
                                          (getCenarioData().totalRH) /*+ ((totalSalariosContratacoes * 1.133)) ) / 12*/
                                        )}
                                      </strong>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {/* ADICIONE O MODAL NO FINAL, ANTES DO FECHAMENTO DO COMPONENTE */}
      {/* Modals */}
      {showSalaryModal && <SalaryModal />}
      {showChargesModal && <ChargesModal />}
      {showDissidioModal && <DissidioModal />}
      {showDissidioGeralModal && <DissidioGeralModal />}
      {showMeritoModal && <MeritoModal />}
    </div>
  );
};

export default HRBudgetSystem;
